const Swal = require("sweetalert2");
const UserInfo = require("./UserInfo");
const MainSettings = require("./MainSettings");
const MachineInfo = require("./MachineInfo");
const Utils = require("../utils/Utils");
const ActionID = require("../utils/ActionID");
const RemoteServer = require("../utils/RemoteServer");
const EPage = require("../utils/EPage");
const EFunction = require("../utils/FunctionPage");
const ProtocolCmd = require("../utils/ProtocolCmd");
const RequestID = require("../utils/RequestID");
// const { default: MainPage } = require("../component/MainPage");
const Config = require("../utils/Config");
const SyncDataID = require("../utils/SyncDataID");
const LANGUAGE_TYPE = require("../utils/Language");
const UILayout = require("../utils/UILayout");
const ScreenOrientation = require("../utils/Orientation");
const LayoutType = require("../utils/LayoutType");
const useAlert = require("../hook/useAlert");

function CAppCtrl() {
  let curPage = EPage.none;
  let fncSetPage = null;
  let fncSetUserCoins = null;
  let fncSetGuoZhao = null;
  let fncSetScoreMsg = null;
  let fncSetLobbyInfos = null;
  let fncSetLobbyMachines = null;
  let fncSetBroadcastMsgs = null;
  let fncSetBonusBroadcast = null;
  let fncSetGameplay = null;
  let fncSetBonusState = null;
  let fncSetBetWinData = null;
  let fncSetBoosting = null;
  let fncOnLockMachine = null;
  let fncOnUnlockMachine = null;
  let fncOnLockSpyMachine = null;
  let fncOnUnlockSpyMachine = null;
  let fncSetAtgGames = null;
  let fncSetAtgGameUrl = null;
  let fncSetRsgGames = null;
  let fncSetRsgGameUrl = null;
  let appId = null;

  const mFunctionHistory = [];

  let mMiddleServer = null;
  let mTextConverter = null;
  let mUniPlayList = null;
  let mMainSettings = MainSettings.create();
  let mUserInfo = UserInfo.create();
  let mMachineInfo = MachineInfo.create();
  let mSpyMachineInfo = MachineInfo.create();
  let mChatHistory = [];
  let mLobbies = null;
  let mLobbyMachines = {};
  let mLobbyName = null;
  let mLayoutType = LayoutType.Normal;
  let mLockedMachine = null;
  let mSpyingMachine = null;
  let mModalConfirmbCBFunc = null;

  let cbSubtractUserCoinsDone = null;
  let cbIncreaseUserCoinsDone = null;
  let cbConnectToServerDone = null;
  let cbReconnectToServerDone = null;
  let cbLoginDone = null;
  let cbAddLoginInfoDone = null;
  let cbCheckLoginInfoDone = null;
  let cbUserTransferCoinsDone = null;
  let cbGetUserGiftRecordsDone = null;
  let cbGetScoresDone = null;
  let cbGetUserPlayRecordsDone = null;
  let cbGetUserInfoDone = null;
  let cbGetUserScoresDone = null;
  let cbGetMachineInfos = null;
  let cbExchangeTrialToFormalDone = null;
  let cbExchangeFormalToTrialDone = null;
  let cbExchangeBetRewardToFormalDone = null;
  let cbExchangeUniPlayToFormalDone = null;
  let cbExchangeFormalToUniPlayDone = null;
  let cbStartUniPlayDone = null;
  let cbStopUniPlayDone = null;
  let mLanguage = Config.language;
  let mCasinoName = "Online Casino";
  let mFullscreenInBonusView = false;
  let mshowBtnSpy = false;
  let mshowBtnDesc = false;
  let mshowtrialCoins = false;
  let mshowjackpotDisplay = false;
  let mkeyboard = true;
  let mBroadcastMsgs = [];
  let mRegisterGM = "WinLobby";
  //let mPrefix = 'W_';
  let mPrefix = "";
  let mRegisterNotice = "";
  let mWainZhu = 0;
  let mbUserOnGuoZhao = false;
  // let mbFullScreen = false;
  let mbIsInLobby = false;
  let mCheckOrientation = true;
  let mCheckOrientationInLobby = true;
  let mHeartbeatNoAckCnt = 0;
  let mShowKeyInCnt = true;
  let mShowPlayerLevel = 0;
  let mbNewLogin = false;
  let mNeedGobackMachine = false;
  //Here
  let mRobotLobbyNum = 2;
  let mRobotMode = false;
  // 新增：機器人「退出直達 Login」機率（0~1，預設 0 關閉）
  let mRobotBackToLoginRate = 0.3;
  let mDebugForbidden = true;
  let mCacheAccount = null;
  let mCachePassword = null;
  let mHdlGetUserInfo = null;
  let mWinAward = false;
  // Machine Token
  let mMachineToken = null;
  let mMachineTokenCB = null;

  let newBonusAccount = null;

  let mStartUniPlay = false;

  let mIsMachineTokenInLobby = false;
  let mDefaultLobbyName = null;
  let mSkipCheckUniPlayState = false;
  let mSourceWin = null;
  let mOriginDomain = null;

  let mAtgGames = null;
  let cbLeaveAtgGames = null;
  let cbLeaveRsgGames = null;
  let cbRequestTopUpToGame = null;

  const { showAlert } = useAlert.default();

  function onConnected() {
    if (cbConnectToServerDone) {
      cbConnectToServerDone();
      cbConnectToServerDone = null;
    }
    // reset mHeartbeatNoAckCnt to avoid trigger alert
    mHeartbeatNoAckCnt = 0;
    // update meta
    const meta = document.querySelector("meta[name=info]");
    if (meta)
      meta.setAttribute(
        "content",
        `connectionId=${mMiddleServer.connectionId()},account=${
          mUserInfo.Account
        }`
      );
  }

  function onReconnected() {
    switch (curPage) {
      case EPage.main:
        {
        }
        break;
      case EPage.lobby:
        {
          const lobbyName = AppCtrl.lobbyName();
          AppCtrl.getMachineInfos(lobbyName, (objs) => {
            const lobbyMachines = AppCtrl.parseMachineInfos(objs);
            AppCtrl.setLobbyMachines(lobbyMachines);
          });
        }
        break;
      case EPage.playClassic:
      case EPage.playBJ:
        {
          // to check if machine isn't for user,
          // popup alert and call unlockMachine()
          const lobbyName = AppCtrl.lobbyName();
          AppCtrl.getMachineInfos(lobbyName, (objs) => {
            const lobbyMachines = AppCtrl.parseMachineInfos(objs);
            AppCtrl.setLobbyMachines(lobbyMachines);
            // check if machine player changed...
            if (mUserInfo && mLockedMachine) {
              const deviceId = mLockedMachine.deviceId;
              const machineId = mLockedMachine.machineId;
              // try relock machine
              AppCtrl.lockMachine(deviceId, machineId, false, (objRes) => {
                if (objRes.status == "success") {
                  if (mMiddleServer) {
                    mMiddleServer.clrRetryReconnectCntInMachine();
                  } else {
                    showAlert({ title: "mMiddleServer為空值。EID:0991" });
                    // this.alert("mMiddleServer??�空??��??EID:0991");
                  }
                } else {
                  AppCtrl.unlockMachine(false);
                  onUnlockMachine({ status: "success" });
                  showAlert({
                    title: `網路斷線，請退回${AppCtrl.lobbyName()}重選遊戲，如無法進入遊戲則請關閉瀏覽器並重新登入遊戲。EID:0991`,
                  });
                  // AppCtrl.alert(
                  //   `網路??��??�?�???????${AppCtrl.lobbyName()}?????��????��??�???��????��?��????��??�??????????覽�?�並?????��?��?��????��??EID:0991`
                  // );
                }
              });
            }
          });
        }
        break;
      case EPage.reload:
        {
        }
        break;
    }
    AppCtrl.setScoreMsg("");
    AppCtrl.setScoreMsg("重新連線中...");
    console.log("onReconnected");
    if (cbReconnectToServerDone) {
      cbReconnectToServerDone();
      cbReconnectToServerDone = null;
    }
    // update meta
    const meta = document.querySelector("meta[name=info]");
    if (meta)
      meta.setAttribute(
        "content",
        `connectionId=${mMiddleServer.connectionId()},account=${
          mUserInfo.Account
        }`
      );
  }

  function onDisconnected(errMsg) {
    console.log(`onDisconnected got ${errMsg}`);

    switch (curPage) {
      case EPage.main:
        {
        }
        break;
      case EPage.lobby:
        {
        }
        break;
      case EPage.playClassic:
      case EPage.playBJ:
        {
          AppCtrl.unlockMachine(false);
          onUnlockMachine({ status: "success" });
        }
        break;
      case EPage.reload:
        {
        }
        break;
    }
    AppCtrl.setScoreMsg(`斷線:${errMsg}`);
    // show mask on screen
    showAlert({
      title: `網路斷線了，請按重新連線鈕重新連線，如無法重新連線則請關閉瀏覽器並重新登入遊戲。EID:099`,
    });
    // AppCtrl.alert(
    //   "網路斷線了，請按重新連線鈕重新連線，如無法重新連線則請關閉瀏覽器並重新登入遊戲。EID:099"
    // );
  }

  function onReceive(cmd, data) {
    switch (cmd) {
      case ProtocolCmd.NotifyJoin:
        onNotifyJoin(data);
        break;
      case ProtocolCmd.NotifyLeave:
        onNotifyLeave(data);
        break;
      // case ProtocolCmd.ResponseGroupInfo: onResponseGroupInfo(data); break;
      case ProtocolCmd.Action:
        onAction(data);
        break;
      case ProtocolCmd.Request:
        onRequest(data);
        break;
      case ProtocolCmd.Response:
        onResponse(data);
        break;
      case ProtocolCmd.ConnectionStatus:
        onConnectionStatus(data);
        break;
      // case ProtocolCmd.GetConnectionDetails: onGetConnectionDetails(data); break;
      case ProtocolCmd.NotifyConfig:
        onNotifyConfig(data);
        break;
      case ProtocolCmd.NotifyLobbies:
        onNotifyLobbies(data);
        break;
      case ProtocolCmd.NotifyAtgGames:
        onNotifyAtgGames(data);
        break;
      case ProtocolCmd.NotifyJoinAtgGames:
        onNotifyJoinAtgGames(data);
        break;
      case ProtocolCmd.NotifyLeaveAtgGames:
        onNotifyLeaveAtgGames(data);
        break;
      case ProtocolCmd.NotifyRsgGames:
        onNotifyRsgGames(data);
        break;
      case ProtocolCmd.NotifyJoinRsgGames:
        onNotifyJoinRsgGames(data);
        break;
      case ProtocolCmd.NotifyLeaveRsgGames:
        onNotifyLeaveRsgGames(data);
        break;
      case ProtocolCmd.RequestTopUpToGame:
        onRequestTopUpToGame(data);
        break;
      //   onNotifyLeaveRsgGames(data);
      //   break;
      // case ProtocolCmd.IISAck: onIISAck(data); break;
      default:
        console.log(`cmd:${cmd}`);
        break;
    }
  }

  function onHeartbeatNoAck() {
    mHeartbeatNoAckCnt++;

    if (mHeartbeatNoAckCnt < 5) {
      AppCtrl.reconnectToServer(function () {
        const middleServer = AppCtrl.middleServer();
        if (middleServer.isConnected()) {
          // do join again
          const lobbyName = AppCtrl.lobbyName();
          const lockedMachine = AppCtrl.lockedMachine();
          if (lobbyName) {
            AppCtrl.joinLobby(lobbyName, true);
            // if user had locked machine, relock it
            if (lockedMachine) {
              // show mask on screen
              showAlert({
                title: "網路不穩定，請按遊戲按鈕檢查機台是否仍可控制。",
              });
              // AppCtrl.alert("網路不穩定，請按遊戲按鈕檢查機台是否仍可控制。");
            }
          }
        } else {
          // show mask on screen
          showAlert({
            title: "網路自動重連線失敗，請關閉瀏覽器並重新登入遊戲。",
          });
          // AppCtrl.alert("網路自動重連線失敗，請關閉瀏覽器並重新登入遊戲。");
        }
      });
    } else {
      // show mask on screen
      showAlert({ title: "網路斷線了，請重新登入遊戲。" });
      // AppCtrl.alert("網路斷線了，請重新登入遊戲。");
      AppCtrl.switchPage(EPage.reload);
    }
  }

  // function openModal(
  //   content,
  //   subcontent,
  //   iconType,
  //   showButton,
  //   buttonText,
  //   showLoading,
  //   closetimer
  // ) {
  //   const uiModal = document.getElementById("myModal");
  //   if (uiModal) {
  //     // show modal
  //     //uiModal.style.display = "block";
  //     // assign content
  //     const uiModalContent = document.getElementById("modalContent");
  //     if (uiModalContent) {
  //       if (showLoading) {
  //         const config = {
  //           title: content,
  //           text: subcontent,
  //           allowEscapeKey: false,
  //           allowOutsideClick: false,
  //           //timer: closetimer,
  //           showConfirmButton: showButton,
  //           didOpen: () => {
  //             Swal.showLoading();
  //           },
  //         };
  //         if (iconType) config.icon = iconType;
  //         if (buttonText) config.confirmButtonText = buttonText;
  //         if (closetimer > 0) config.timer = closetimer;

  //         Swal.fire(config).then(function (result) {
  //           //then((result) => {
  //           //Read more about isConfirmed, isDenied below
  //           if (result.dismiss === Swal.DismissReason.timer) {
  //             console.log("closed by timer!!!!");
  //           }
  //         });
  //       } else {
  //         const config = {
  //           title: content,
  //           text: subcontent,
  //           allowEscapeKey: false,
  //           allowOutsideClick: false,
  //           showConfirmButton: showButton,
  //         };
  //         if (iconType) config.icon = iconType;
  //         if (buttonText) config.confirmButtonText = buttonText;
  //         if (closetimer > 0) config.timer = closetimer;

  //         Swal.fire(config).then(function (result) {
  //           if (result.isConfirmed) {
  //             Swal.close();
  //             TotalMsg = "";
  //           }
  //         });
  //       }
  //     }
  //   }
  // }
  ////In Lobby
  // 新增 setter
  CAppCtrl.prototype.setRobotMode = function (isRobot) {
    mRobotMode = !!isRobot;
  };
  // 新增 getter
  CAppCtrl.prototype.isRobotMode = function () {
    return mRobotMode;
  };
  CAppCtrl.prototype.getRobotLobbyNum = function () {
    return mRobotLobbyNum;
  };
  // 新增：設定/取得 機器人退出直達 Login 的機率（0~1）
  CAppCtrl.prototype.setRobotBackToLoginRate = function (rate) {
    const n = Number(rate);
    if (Number.isFinite(n)) {
      // 夾在 [0, 1]
      const clamped = Math.max(0, Math.min(1, n));
      mRobotBackToLoginRate = clamped;
    }
  };
  CAppCtrl.prototype.getRobotBackToLoginRate = function () {
    return mRobotBackToLoginRate;
  };

  // 新增：是否此次要直達 Login（隨機依機率決定）
  CAppCtrl.prototype.shouldRobotBackToLogin = function () {
    if (!this.isRobotMode()) return false;
    const p = mRobotBackToLoginRate || 0;
    if (p <= 0) return false;
    if (p >= 1) return true;
    return Math.random() < p;
  };

  CAppCtrl.prototype.LandscapePortraitSetInLobby = function (Orientation) {
    if (AppCtrl.isRobotMode()) return;
    let renew = false;
    let orientationLlock = Config.orientationLlock
      ? Config.orientationLlock
      : false;
    const bMobile = Utils.detectmob();
    if (!bMobile) return;
    if (mOrientationInLobby != Orientation) renew = true;

    if (!Utils.detectmobiOS() && renew && mOrientationInLobby != null) {
      mOrientationInLobby = Orientation;
      if (orientationLlock) {
        if (screen.orientation.lock) {
          // 设备支持屏幕方向锁定
          screen.orientation.unlock();
          screen.orientation.lock(mOrientationInLobby);
        }
      }
      Utils.enterFullScreen();
    }
  };
  CAppCtrl.prototype.SetOrientationInLobby = function (Orientation) {
    let orientationLlock = Config.orientationLlock
      ? Config.orientationLlock
      : false;
    let bCreateSuccess = false;
    let renew = false;
    let bMobile = Utils.detectmob();
    if (!bMobile) return;
    if (mOrientationInLobby != Orientation) renew = true;
    if (renew === false) {
      if (mChkRotatTimerInLobby) {
        clearInterval(mChkRotatTimerInLobby);
        mChkRotatTimerInLobby = null;
      }
      if (!mChkRotatTimerInLobby)
        mChkRotatTimerInLobby = setInterval(checkOrientationInLobby, 500);
      return;
    }

    bCreateSuccess = this.CreateScreenMaskInLobby();
    if (bCreateSuccess) {
      mOrientationInLobby = Orientation;
      if (!Utils.detectmobiOS()) {
        if (orientationLlock) {
          screen.orientation.unlock();
          screen.orientation.lock(mOrientationInLobby);
        }

        screen.orientation.addEventListener("change", onChange);
        document.addEventListener("fullscreenchange", onChange);
      }

      window.addEventListener("resize", checkOrientationInLobby, false);
      window.addEventListener(
        "orientationchange",
        checkOrientationInLobby,
        false
      );
      if (!mChkRotatTimerInLobby)
        mChkRotatTimerInLobby = setInterval(checkOrientationInLobby, 500);
    }
  };
  CAppCtrl.prototype.FreeOrientationInLobby = function () {
    const bMobile = Utils.detectmob();
    if (!bMobile) return;

    if (mOrientationInLobby != null) {
      if (!Utils.detectmobiOS()) {
        screen.orientation.removeEventListener("change", onChange);
        screen.orientation.unlock();
        document.removeEventListener("fullscreenchange", onChange);
      }

      window.removeEventListener("resize", checkOrientationInLobby, false);
      window.removeEventListener(
        "orientationchange",
        checkOrientationInLobby,
        false
      );
      if (mChkRotatTimerInLobby) {
        clearInterval(mChkRotatTimerInLobby);
        mChkRotatTimerInLobby = null;
      }
      const uiMainArea = document.getElementById("mainAreaInLobby");
      if (!uiMainArea) return;
      let uiscreenmask = document.getElementById("screenmaskInLobby");
      if (uiscreenmask) {
        uiMainArea.removeChild(uiscreenmask);
      }
      mOrientationInLobby = null;
    }
  };
  var mOrientationInLobby = null;
  var mChkRotatTimerInLobby = null;
  var mbLoadRotatAnimationInLobby = false;
  CAppCtrl.prototype.CreateScreenMaskInLobby = function () {
    let bCreateSuccess = false;
    let bMobile = Utils.detectmob();
    if (!bMobile) return bCreateSuccess;

    const uiMainArea = document.getElementById("mainAreaInLobby");
    if (!uiMainArea) return bCreateSuccess;
    let uiscreenmask = document.getElementById("screenmaskInLobby");
    if (!uiscreenmask) {
      uiscreenmask = document.createElement("img");
      uiscreenmask.id = "screenmaskInLobby";
      uiscreenmask.type = "image";
      uiscreenmask.src = "img/ChooseMachine/portrait.gif";
      uiscreenmask.name = "submit";
      uiscreenmask.style.position = "absolute";
      uiscreenmask.style.left = "50%";
      uiscreenmask.style.top = "50%";
      uiscreenmask.style.width = "50%";
      uiscreenmask.style.height = "50%";
      uiscreenmask.style.transform = "translate(-50%,-50%)";
      uiscreenmask.style.zIndex = 99;
      uiMainArea.appendChild(uiscreenmask);
      bCreateSuccess = true;
    }
    return bCreateSuccess;
  };
  CAppCtrl.prototype.DeleteScreenMaskInLobby = function () {
    let bMobile = Utils.detectmob();
    if (!bMobile) return;

    const uiMainArea = document.getElementById("mainAreaInLobby");
    if (!uiMainArea) return;
    let uiscreenmask = document.getElementById("screenmaskInLobby");
    if (uiscreenmask) {
      uiMainArea.removeChild(uiscreenmask);
    }
  };
  function showScreenMaskInLobby(bShow) {
    const uiScreenmask = document.getElementById("screenmaskInLobby");
    if (uiScreenmask) uiScreenmask.style.display = bShow ? "" : "none";
  }
  function checkOrientationInLobby() {
    const bCheckOrientationInLobby = AppCtrl.CheckOrientationInLobby();

    if (!bCheckOrientationInLobby) {
      return;
    }
    const bMobileDevice = Utils.detectmob();
    if (!bMobileDevice) {
      mbLoadRotatAnimationInLobby = false;
      showScreenMaskInLobby(mbLoadRotatAnimationInLobby);
      return;
    }

    let matchType = "portrait";
    if (
      mOrientationInLobby === ScreenOrientation.LandscapePrimary ||
      mOrientationInLobby === ScreenOrientation.LandscapeSecondary
    )
      matchType = "landscape";
    let mode = window.matchMedia(`(orientation: ${matchType})`);
    // ??? 在 Android 上使用 Opera Mobile 測試, 發現要另外這樣判斷
    const bOpera = navigator.userAgent.match(/Opera|OPR\//) ? true : false;
    if (bOpera) {
      const width = window.screen.width;
      const height = window.screen.height;
      mode = width > height ? landscape : portrait;
    }

    // 本例為希望在使用者用橫向瀏覽時，就秀出遮罩或警示訊息
    if (mode.matches) {
      mbLoadRotatAnimationInLobby = false;
      showScreenMaskInLobby(mbLoadRotatAnimationInLobby);
    } else {
      const uiMainArea = document.getElementById("mainAreaInLobby");
      if (!uiMainArea) return;
      let uiscreenmask = document.getElementById("screenmaskInLobby");
      if (!uiscreenmask) {
        uiscreenmask = document.createElement("img");
        uiscreenmask.id = "screenmaskInLobby";
        uiscreenmask.type = "image";
        uiscreenmask.src = `img/ChooseMachine/portrait.gif?${Math.random()}`; //landscape
        uiscreenmask.name = "submit";
        uiscreenmask.style.position = "absolute";
        uiscreenmask.style.left = "50%";
        uiscreenmask.style.top = "50%";
        uiscreenmask.style.width = "50%";
        uiscreenmask.style.height = "50%";
        uiscreenmask.style.transform = "translate(-50%,-50%)";
        uiscreenmask.style.zIndex = 99;
        uiMainArea.appendChild(uiscreenmask);
      }
      if (uiscreenmask) {
        if (
          mOrientationInLobby === ScreenOrientation.LandscapePrimary ||
          mOrientationInLobby === ScreenOrientation.LandscapeSecondary
        ) {
          uiscreenmask.src = `img/ChooseMachine/landscape.gif?${Math.random()}`; //portrait
          mbLoadRotatAnimationInLobby = true;
        } else {
          uiscreenmask.src = `img/ChooseMachine/portrait.gif?${Math.random()}`; //landscape
          mbLoadRotatAnimationInLobby = true;
        }

        showScreenMaskInLobby(mbLoadRotatAnimationInLobby);
      }
      setTimeout(function () {
        ForceLandscapePortraitSetInLobby();
      }, 500);
    }
  }
  function ForceLandscapePortraitSetInLobby() {
    if (AppCtrl.isRobotMode()) return;
    let orientationLlock = Config.orientationLlock
      ? Config.orientationLlock
      : false;
    if (!Utils.detectmobiOS()) {
      //mOrientationInLobby = Orientation;
      if (orientationLlock) {
        if (screen.orientation.lock) {
          // 设备支持屏幕方向锁定
          screen.orientation.unlock();
          screen.orientation.lock(mOrientationInLobby);
        }
      }
      Utils.enterFullScreen();
    }
  }
  /////////////
  var mbLoadRotatAnimation = false;
  var mChkRotatTimer = null;
  function showScreenMask(bShow) {
    const uiScreenmask = document.getElementById("screenmask");
    if (uiScreenmask) uiScreenmask.style.display = bShow ? "" : "none";
  }
  function checkOrientation() {
    const bCheckOrientation = AppCtrl.CheckOrientation();

    if (!bCheckOrientation) {
      return;
    }
    const bMobileDevice = Utils.detectmob();
    if (!bMobileDevice) {
      mbLoadRotatAnimation = false;
      showScreenMask(mbLoadRotatAnimation);
      return;
    }

    let matchType = "portrait";
    if (
      mOrientation === ScreenOrientation.LandscapePrimary ||
      mOrientation === ScreenOrientation.LandscapeSecondary
    )
      matchType = "landscape";
    let mode = window.matchMedia(`(orientation: ${matchType})`);
    // ??? 在 Android 上使用 Opera Mobile 測試, 發現要另外這樣判斷
    const bOpera = navigator.userAgent.match(/Opera|OPR\//) ? true : false;
    if (bOpera) {
      const width = window.screen.width;
      const height = window.screen.height;
      mode = width > height ? landscape : portrait;
    }
    let uiscreenmask = document.getElementById("screenmask");

    // 本例為希望在使用者用橫向瀏覽時，就秀出遮罩或警示訊息
    if (mode.matches) {
      mbLoadRotatAnimation = false;
      showScreenMask(mbLoadRotatAnimation);
    } else {
      if (uiscreenmask) {
        if (
          mOrientation === ScreenOrientation.LandscapePrimary ||
          mOrientation === ScreenOrientation.LandscapeSecondary
        ) {
          uiscreenmask.src = `img/ChooseMachine/landscape.gif?${Math.random()}`; //portrait
          mbLoadRotatAnimation = true;
        } else {
          uiscreenmask.src = `img/ChooseMachine/portrait.gif?${Math.random()}`; //landscape
          mbLoadRotatAnimation = true;
        }

        showScreenMask(mbLoadRotatAnimation);
      }
    }
  }
  var mOrientation = ScreenOrientation.LandscapePrimary;
  function onChange(e) {
    if (AppCtrl.isRobotMode()) return;
    let orientationLlock = Config.orientationLlock
      ? Config.orientationLlock
      : false;
    if (screen.orientation.lock) {
      if (orientationLlock) {
        // 设备支持屏幕方向锁定
        screen.orientation.unlock();
        //Utils.exitFullscreen();
        screen.orientation.lock(mOrientation);
        //screen.lockOrientation("landscape");
      }
      Utils.enterFullScreen();
    } else {
      // 设备不支持屏幕方向锁定
      showAlert({ title: "不支援鎖定方向" });
      // AppCtrl.alert("不支援鎖定方向");
      console.log(`不支援鎖定方向`);
    }
  }
  /* async function lockOrientation(Orientation) { 
        // 首先進入全屏模式 
        await document.documentElement.requestFullscreen(); 
        // 鎖定橫屏方向
        await screen.orientation .lock(Orientation) .catch(e => alert(e.message));
  } */
  CAppCtrl.prototype.LandscapePortraitSet = function (Orientation) {
    if (AppCtrl.isRobotMode()) return;
    let orientationLlock = Config.orientationLlock
      ? Config.orientationLlock
      : false;
    let renew = false;
    const bMobile = Utils.detectmob();
    if (!bMobile) return;
    if (mOrientation != Orientation) renew = true;
    mOrientation = Orientation;
    if (!Utils.detectmobiOS() && renew) {
      if (orientationLlock) {
        if (screen.orientation.lock) {
          // 设备支持屏幕方向锁定
          screen.orientation.unlock();
          screen.orientation.lock(mOrientation);
        }
      }
      Utils.enterFullScreen();
    }
  };
  CAppCtrl.prototype.SetOrientation = function (Orientation) {
    let orientationLlock = Config.orientationLlock
      ? Config.orientationLlock
      : false;
    let bMobile = Utils.detectmob();
    if (!bMobile) return;

    mOrientation = Orientation;
    if (!Utils.detectmobiOS()) {
      if (orientationLlock) {
        screen.orientation.unlock();
        screen.orientation.lock(mOrientation);
        //screen.lockOrientation("landscape");
      }
      screen.orientation.addEventListener("change", onChange);
      document.addEventListener("fullscreenchange", onChange);
    }
    this.CreateScreenMask();
    window.addEventListener("resize", checkOrientation, false);
    window.addEventListener("orientationchange", checkOrientation, false);
    if (!mChkRotatTimer) mChkRotatTimer = setInterval(checkOrientation, 500);
  };
  CAppCtrl.prototype.FreeOrientation = function () {
    const bMobile = Utils.detectmob();
    if (!bMobile) return;

    if (!Utils.detectmobiOS()) {
      screen.orientation.removeEventListener("change", onChange);
      screen.orientation.unlock();
      document.removeEventListener("fullscreenchange", onChange);
    }

    window.removeEventListener("resize", checkOrientation, false);
    window.removeEventListener("orientationchange", checkOrientation, false);
    if (mChkRotatTimer) {
      clearInterval(mChkRotatTimer);
      mChkRotatTimer = null;
    }
    const uiMainArea = document.getElementById("mainArea");
    if (!uiMainArea) return;
    let uiscreenmask = document.getElementById("screenmask");
    if (uiscreenmask) {
      uiMainArea.removeChild(uiscreenmask);
    }
  };
  CAppCtrl.prototype.CreateScreenMask = function () {
    let bMobile = Utils.detectmob();
    if (!bMobile) return;

    const uiMainArea = document.getElementById("mainArea");
    if (!uiMainArea) return;
    let uiscreenmask = document.getElementById("screenmask");
    if (!uiscreenmask) {
      uiscreenmask = document.createElement("img");
      uiscreenmask.id = "screenmask";
      uiscreenmask.type = "image";
      uiscreenmask.src = "img/ChooseMachine/portrait.gif";
      uiscreenmask.name = "submit";
      uiscreenmask.style.position = "absolute";
      uiscreenmask.style.left = "50%";
      uiscreenmask.style.top = "50%";
      uiscreenmask.style.width = "50%";
      uiscreenmask.style.height = "50%";
      uiscreenmask.style.transform = "translate(-50%,-50%)";
      uiscreenmask.style.zIndex = 99;
      uiMainArea.appendChild(uiscreenmask);
    }
  };
  CAppCtrl.prototype.DeleteScreenMask = function () {
    let bMobile = Utils.detectmob();
    if (!bMobile) return;

    const uiMainArea = document.getElementById("mainArea");
    if (!uiMainArea) return;
    let uiscreenmask = document.getElementById("screenmask");
    if (uiscreenmask) {
      uiMainArea.removeChild(uiscreenmask);
    }
  };
  CAppCtrl.prototype.EFunction = function () {
    return EFunction;
  };

  CAppCtrl.prototype.curFunction = function () {
    const curPage =
      mFunctionHistory.length > 0
        ? mFunctionHistory[mFunctionHistory.length - 1]
        : EFunction.none;
    console.log(curPage);
    // make sure to show/hide correct uiElement
    const curElement = document.getElementById(curPage);
    if (curElement && curElement.style.display == "none") {
      const keys = Object.keys(EFunction);
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const elementId = EFunction[key];
        const uiElement = document.getElementById(elementId);
        if (uiElement)
          uiElement.style.display = uiElement.id == curElement.id ? "" : "none";
      }
    }
    return curPage;
  };

  CAppCtrl.prototype.init = function () {
    const urlParams = Utils.getURLParameter();
    const deviceName = urlParams["deviceName"]
      ? decodeURIComponent(urlParams["deviceName"])
      : null;
    appId = urlParams["appId"] ? decodeURIComponent(urlParams["appId"]) : null;

    const CGateServer = require("../utils/GateServer");
    mMiddleServer = new CGateServer();
    mMiddleServer.init(
      deviceName,
      onConnected,
      onReconnected,
      onDisconnected,
      onReceive,
      onHeartbeatNoAck
    );

    const CTextConverter = require("../utils/TextConverter");
    mTextConverter = new CTextConverter();
    mTextConverter.loadText(Config.language);
  };

  CAppCtrl.prototype.connectToServer = function (domain, fncCB) {
    if (mMiddleServer) {
      cbConnectToServerDone = fncCB;
      // stop if connected
      let delay = 0;
      if (mMiddleServer.isConnected()) {
        mMiddleServer.stop();
        delay = 300;
      }
      setTimeout(function () {
        // to get server ip & port
        Utils.getGateServer(domain)
          .then((gateServer) => {
            // store uniPlayList for null domain
            if (!domain) {
              // clear
              mUniPlayList = [];
              // add appliable uniPlay
              const uniPlayList = gateServer.uniPlayList;
              for (let i = 0; i < uniPlayList.length; i++) {
                const objUniPlay = uniPlayList[i];
                if (objUniPlay["appliable"]) mUniPlayList.push(objUniPlay);
              }
            }
            // connect to server
            mMiddleServer.start({
              protocol: gateServer.protocol,
              domain: gateServer.domain,
              ip: gateServer.ip,
              port: gateServer.port,
            });
          })
          .catch((err) => {
            console.log(err.message ? err.message : err);
          });
      }, delay);
    } else {
      showAlert({ title: "mMiddleServer為空值" });
      // this.alert("mMiddleServer為空值");
    }
  };

  CAppCtrl.prototype.reconnectToServer = function (fncCB) {
    if (mMiddleServer) {
      cbReconnectToServerDone = fncCB;
      mMiddleServer.reconnect();
    } else {
      showAlert({ title: "mMiddleServer為空值" });
      // this.alert("mMiddleServer為空值");
    }
  };

  CAppCtrl.prototype.assignApp = function (data) {
    const {
      onPage,
      onUserCoins,
      onGuoZhao,
      onScoreMsg,
      onLobbyInfos,
      onLobbyMachines,
      onBroadcastMsgs,
      onBonusBroadcast,
      onGameplay,
      onBetWinData,
      onBonusState,
      onBoosting,
      onAtgGames,
      onAtgGameUrl,
      onRsgGames,
      onRsgGameUrl,
    } = data;
    fncSetPage = onPage;
    fncSetUserCoins = onUserCoins;
    fncSetGuoZhao = onGuoZhao;
    fncSetScoreMsg = onScoreMsg;
    fncSetLobbyInfos = onLobbyInfos;
    fncSetLobbyMachines = onLobbyMachines;
    fncSetBroadcastMsgs = onBroadcastMsgs;
    fncSetBonusBroadcast = onBonusBroadcast;
    fncSetGameplay = onGameplay;
    fncSetBetWinData = onBetWinData;
    fncSetBonusState = onBonusState;
    fncSetBoosting = onBoosting;
    fncSetAtgGames = onAtgGames;
    fncSetAtgGameUrl = onAtgGameUrl;
    fncSetRsgGames = onRsgGames;
    fncSetRsgGameUrl = onRsgGameUrl;
    this.switchPage(EPage.main);
  };

  CAppCtrl.prototype.setPage = function (obj) {
    if (fncSetPage) fncSetPage(obj);
    else console.log("fncSetPage is null");
  };

  CAppCtrl.prototype.setUserCoins = function (obj, code) {
    console.log(`code:${code} obj:${JSON.stringify(obj)}`);

    if (obj.hasOwnProperty("coins")) obj["coins"] = Math.floor(obj["coins"]);
    if (obj.hasOwnProperty("trialCoins"))
      obj["trialCoins"] = Math.floor(obj["trialCoins"]);
    if (obj.hasOwnProperty("uniPlayCoins"))
      obj["uniPlayCoins"] = Math.floor(obj["uniPlayCoins"]);
    if (obj.hasOwnProperty("guoZhaoCoins"))
      obj["guoZhaoCoins"] = Math.floor(obj["guoZhaoCoins"]);
    if (obj.hasOwnProperty("betReward"))
      obj["betReward"] = Math.round(obj["betReward"] * 10) / 10;
    if (obj.hasOwnProperty("wainZhus"))
      obj["wainZhus"] = Math.floor(obj["wainZhus"]);

    if (fncSetUserCoins) fncSetUserCoins(obj);
    if (Config.logingFromMachine) {
      const coins = obj.coins;
      const srcWin = AppCtrl.getSourceWin();
      const oriDomain = AppCtrl.getOriginDomain();
      if (srcWin && oriDomain) {
        AppCtrl.getSourceWin().postMessage(
          {
            type: "RESPONSE_PLAYER_BALANCE",
            Balance: coins,
            Result: "SUCCESS",
          },
          AppCtrl.getOriginDomain()
        );
      }
    }
  };

  CAppCtrl.prototype.setSourceWin = function (scrWin) {
    mSourceWin = scrWin;
  };
  CAppCtrl.prototype.getSourceWin = function () {
    return mSourceWin;
  };
  CAppCtrl.prototype.setOriginDomain = function (oriDomain) {
    mOriginDomain = oriDomain;
  };
  CAppCtrl.prototype.getOriginDomain = function () {
    return mOriginDomain;
  };

  CAppCtrl.prototype.setGuoZhao = function (obj) {
    console.log(`setGuoZhao obj:${obj ? JSON.stringify(obj) : "null"}`);
    if (fncSetGuoZhao) fncSetGuoZhao(obj);
  };

  CAppCtrl.prototype.setScoreMsg = function (obj) {
    if (fncSetScoreMsg) fncSetScoreMsg(obj);
  };
  CAppCtrl.prototype.askMachineTokenInLobby = function () {
    //const lobbyName = mLobbies?.[0]?.name ?? undefined;
    const lobbyName = AppCtrl.GetDefaultLobbyName();
    if (lobbyName) {
      mIsMachineTokenInLobby = true;
      const obj = new Object();
      obj["request"] = RequestID.MachineToken;
      obj["lobby"] = lobbyName;
      obj["connectionId"] = AppCtrl.middleServer().connectionId();
      obj["account"] = AppCtrl.getAccount();
      mMiddleServer.invoke(ProtocolCmd.Request, JSON.stringify(obj));
    }
  };
  CAppCtrl.prototype.GetDefaultLobbyName = function () {
    let lobbyName = "";
    if (Config.lobbynotice) {
      if (Config.lobbynotice.length >= 1) {
        lobbyName = Config.lobbynotice[0].id ? Config.lobbynotice[0].id : "";
      }
    }
    const result =
      mDefaultLobbyName !== undefined && mDefaultLobbyName
        ? mDefaultLobbyName
        : lobbyName;
    return result;
  };
  CAppCtrl.prototype.setMachineTokenInLobby = function (isMachineTokenInLobby) {
    mIsMachineTokenInLobby = isMachineTokenInLobby;
  };
  CAppCtrl.prototype.isMachineTokenInLobby = function () {
    return mIsMachineTokenInLobby;
  };
  CAppCtrl.prototype.SetStartUniPlay = function (startUniPlay) {
    mStartUniPlay = startUniPlay;
  };
  CAppCtrl.prototype.isStartUniPlay = function () {
    return mStartUniPlay;
  };
  CAppCtrl.prototype.getLobbyInfos = function () {
    return mLobbies;
  };
  CAppCtrl.prototype.setLobbyInfos = function (obj) {
    mLobbies = obj;
    if (fncSetLobbyInfos) fncSetLobbyInfos(obj);
    mDefaultLobbyName = mLobbies?.[0]?.name ?? undefined;
  };
  CAppCtrl.prototype.getLobbyMachines = function () {
    return mLobbyMachines;
  };
  CAppCtrl.prototype.setLobbyMachines = function (obj) {
    mLobbyMachines = obj;
    if (fncSetLobbyMachines) fncSetLobbyMachines(obj);
  };

  CAppCtrl.prototype.setBroadcastMsgs = function (obj) {
    if (fncSetBroadcastMsgs) fncSetBroadcastMsgs(obj);
  };

  CAppCtrl.prototype.setBonusBroadcast = function (obj) {
    if (fncSetBonusBroadcast) fncSetBonusBroadcast(obj);
  };

  CAppCtrl.prototype.setGameplay = function (obj) {
    if (fncSetGameplay) fncSetGameplay(obj);
  };
  CAppCtrl.prototype.setBonusState = function (obj) {
    if (fncSetBonusState) fncSetBonusState(obj);
  };
  CAppCtrl.prototype.setBetWinData = function (obj) {
    if (fncSetBetWinData) fncSetBetWinData(obj);
  };
  CAppCtrl.prototype.setBoosting = function (obj) {
    if (fncSetBoosting) fncSetBoosting(obj);
  };
  CAppCtrl.prototype.uniPlayList = function () {
    return mUniPlayList;
  };
  CAppCtrl.prototype.uniPlayCheckSkip = function () {
    return mSkipCheckUniPlayState;
  };
  CAppCtrl.prototype.setUniPlayCheckSkip = function (uniPlayCheck) {
    mSkipCheckUniPlayState = uniPlayCheck;
  };
  CAppCtrl.prototype.mainSettings = function () {
    return mMainSettings;
  };

  CAppCtrl.prototype.userInfo = function () {
    return mUserInfo;
  };

  CAppCtrl.prototype.machineInfo = function () {
    return mMachineInfo;
  };

  CAppCtrl.prototype.spyMachineInfo = function () {
    return mSpyMachineInfo;
  };

  CAppCtrl.prototype.middleServer = function () {
    return mMiddleServer;
  };

  CAppCtrl.prototype.textConverter = function () {
    return mTextConverter;
  };

  CAppCtrl.prototype.curPage = function () {
    return curPage;
  };

  CAppCtrl.prototype.appId = function () {
    return appId;
  };

  CAppCtrl.prototype.lobbyName = function () {
    return mLobbyName;
  };
  CAppCtrl.prototype.layoutType = function () {
    return mLayoutType;
  };
  CAppCtrl.prototype.lockedMachine = function () {
    return mLockedMachine;
  };

  CAppCtrl.prototype.spyingMachine = function () {
    return mSpyingMachine;
  };

  CAppCtrl.prototype.machineName = function () {
    return mLockedMachine ? mLockedMachine.MachineName : null;
  };

  CAppCtrl.prototype.GetVerCodeRequired = function () {
    var verCode = Config.VerCode ? Config.VerCode : "1.3.3.0";
    var VerCodeArray = verCode.split(".");
    var power = 0;
    var verCodeRequired = 0;
    for (var i = VerCodeArray.length - 1; i >= 0; i--) {
      var value = parseInt(VerCodeArray[i]);
      var digits = 10 ** power;
      power = power + 1;
      value = value * digits;
      verCodeRequired = verCodeRequired + value;
    }
    return verCodeRequired;
  };

  CAppCtrl.prototype.switchPage = function (newPage) {
    if (curPage != EPage.reload) {
      // check if not in specified page
      const values = Object.values(EPage);
      if (values.indexOf(newPage) >= 0 && curPage != newPage) {
        curPage = newPage;
        // goto new page
        this.setPage(curPage);
        // stop heartbeat if goto reload page
        if (curPage == EPage.reload) mMiddleServer.stopHeartbeat();
        return true;
      }
    }

    return false;
  };

  let TotalMsg = "";
  // CAppCtrl.prototype.alert = function (
  //   message,
  //   subcontent = "",
  //   iconType = "",
  //   showButton = true,
  //   buttonText = "關閉"
  // ) {
  //   while (true) {
  //     let tmp = message.replace("\r", "");
  //     if (tmp == message) break;
  //     message = tmp;
  //   }
  //   while (true) {
  //     let tmp = message.replace("\n", "<br>");
  //     if (tmp == message) break;
  //     message = tmp;
  //   }
  //   const content = `<div style="width:100%;text-align:center">${message}</div>`;
  //   //pop up
  //   if (TotalMsg.search("EID:") == -1 || content.search("EID:") == -1)
  //     TotalMsg += content;

  //   if (TotalMsg.search("EID:") != -1 && TotalMsg.search("廳別名稱") == -1) {
  //     TotalMsg += "\r\n廳別名稱:" + this.getCookie("lobbyName");
  //     TotalMsg += "\r\n機台名稱:" + this.getCookie("machineName");
  //   }
  //   //機台結算中，結算完成後才可開招
  //   if (TotalMsg.search("機台結算中，結算完成後才可開招") != -1) {
  //     TotalMsg = TotalMsg.replace(
  //       "機台結算中，結算完成後才可開招",
  //       "機台結算中，請稍等5分鐘，至機台出現「可遊玩」即可使用開招"
  //     );
  //   }
  //   //機台解召中，請稍後。
  //   if (TotalMsg.search("機台解招中，請稍候。") != -1) {
  //     TotalMsg = TotalMsg.replace(
  //       "機台解招中，請稍候。",
  //       "機台解招中，請稍等5分鐘，至機台出現「可遊玩」即可使用該機台"
  //   }
  //   openModal(TotalMsg, subcontent, iconType, showButton, buttonText, false, 0);
  // };

  // CAppCtrl.prototype.popup = function (
  //   message,
  //   subcontent = "",
  //   iconType = "",
  //   showButton = false,
  //   buttonText = "",
  //   closetimer = 4000
  // ) {
  //   const uiModalClose = document.getElementById("modalClose");
  //   if (uiModalClose) uiModalClose.style.display = "none";

  //   openModal(
  //     message,
  //     subcontent,
  //     iconType,
  //     showButton,
  //     buttonText,
  //     false,
  //     closetimer
  //   );
  // };

  CAppCtrl.prototype.setWainZhu = function (wainZhu) {
    mWainZhu = wainZhu;
  };

  CAppCtrl.prototype.WainZhu = function () {
    return mWainZhu;
  };

  CAppCtrl.prototype.setShowJackpotDisplay = function (showjackpotDisplay) {
    mshowjackpotDisplay = showjackpotDisplay;
  };
  CAppCtrl.prototype.showJackpotDisplay = function () {
    return mshowjackpotDisplay;
  };
  CAppCtrl.prototype.setShowTrialCoins = function (showtrialCoins) {
    mshowtrialCoins = showtrialCoins;
  };

  CAppCtrl.prototype.showTrialCoins = function () {
    return mshowtrialCoins;
  };
  CAppCtrl.prototype.setShowKeyInCnt = function (showKeyInCnt) {
    mShowKeyInCnt = showKeyInCnt;
  };

  CAppCtrl.prototype.showKeyInCnt = function () {
    return mShowKeyInCnt;
  };

  CAppCtrl.prototype.SetNewLogin = function (bNewLogin) {
    mbNewLogin = bNewLogin;
  };
  CAppCtrl.prototype.IsNewLogin = function () {
    return mbNewLogin;
  };
  CAppCtrl.prototype.SetGobackMachine = function (bNeedGobackMachine) {
    mNeedGobackMachine = bNeedGobackMachine;
  };
  CAppCtrl.prototype.NeedGobackMachine = function () {
    return mNeedGobackMachine;
  };

  CAppCtrl.prototype.strEncrypt = function () {
    return Config.strEncrypt;
  };
  //private byte[] Xor(byte[] input, byte[] key)
  CAppCtrl.prototype.Xor = function (input, key) {
    //let output = new byte[input.Length];
    //let output = new ArrayBuffer(input.length);
    let output = [];
    for (var i = 0; i < input.length; i++) {
      //output[i] = (byte)(input[i] ^ key[i % key.Length]);
      output[i] = input[i] ^ key[i % key.length];
    }
    return output;
  };
  CAppCtrl.prototype.strUTF8GetBytes = function (str) {
    var utf8 = [];
    for (var i = 0; i < str.length; i++) {
      var charcode = str.charCodeAt(i);
      if (charcode < 0x80) utf8.push(charcode);
      else if (charcode < 0x800) {
        utf8.push(0xc0 | (charcode >> 6), 0x80 | (charcode & 0x3f));
      } else if (charcode < 0xd800 || charcode >= 0xe000) {
        utf8.push(
          0xe0 | (charcode >> 12),
          0x80 | ((charcode >> 6) & 0x3f),
          0x80 | (charcode & 0x3f)
        );
      }
      // surrogate pair
      else {
        i++;
        // UTF-16 encodes 0x10000-0x10FFFF by
        // subtracting 0x10000 and splitting the
        // 20 bits of 0x0-0xFFFFF into two halves
        charcode =
          0x10000 + (((charcode & 0x3ff) << 10) | (str.charCodeAt(i) & 0x3ff));
        utf8.push(
          0xf0 | (charcode >> 18),
          0x80 | ((charcode >> 12) & 0x3f),
          0x80 | ((charcode >> 6) & 0x3f),
          0x80 | (charcode & 0x3f)
        );
      }
    }
    return utf8;
  };
  CAppCtrl.prototype.bytesUTF8GetString = function (data) {
    // array of bytes
    var str = "",
      i;

    for (i = 0; i < data.length; i++) {
      var value = data[i];

      if (value < 0x80) {
        str += String.fromCharCode(value);
      } else if (value > 0xbf && value < 0xe0) {
        str += String.fromCharCode(
          ((value & 0x1f) << 6) | (data[i + 1] & 0x3f)
        );
        i += 1;
      } else if (value > 0xdf && value < 0xf0) {
        str += String.fromCharCode(
          ((value & 0x0f) << 12) |
            ((data[i + 1] & 0x3f) << 6) |
            (data[i + 2] & 0x3f)
        );
        i += 2;
      } else {
        // surrogate pair
        var charCode =
          (((value & 0x07) << 18) |
            ((data[i + 1] & 0x3f) << 12) |
            ((data[i + 2] & 0x3f) << 6) |
            (data[i + 3] & 0x3f)) -
          0x010000;

        str += String.fromCharCode(
          (charCode >> 10) | 0xd800,
          (charCode & 0x03ff) | 0xdc00
        );
        i += 3;
      }
    }

    return str;
  };

  CAppCtrl.prototype.setShowPlayerLevel = function (showPlayerLevel) {
    mShowPlayerLevel = showPlayerLevel;
  };
  CAppCtrl.prototype.showPlayerLevel = function () {
    return mShowPlayerLevel;
  };
  CAppCtrl.prototype.setShowSpy = function (showBtnSpy) {
    mshowBtnSpy = showBtnSpy;
  };
  CAppCtrl.prototype.showSpy = function () {
    return mshowBtnSpy;
  };

  CAppCtrl.prototype.setShowDesc = function (showBtnDesc) {
    mshowBtnDesc = showBtnDesc;
  };

  CAppCtrl.prototype.showDesc = function () {
    return mshowBtnDesc;
  };
  CAppCtrl.prototype.setWinAward = function (WinAward) {
    mWinAward = WinAward;
  };
  CAppCtrl.prototype.winAward = function (WinAward) {
    return mWinAward;
  };
  CAppCtrl.prototype.setKeyboardEnable = function (keyboard) {
    mkeyboard = keyboard;
  };

  CAppCtrl.prototype.isKeyboardEnable = function () {
    return mkeyboard;
  };

  CAppCtrl.prototype.setFullscreenInBonusView = function (
    fullscreenInBonusView
  ) {
    mFullscreenInBonusView = fullscreenInBonusView;
  };

  CAppCtrl.prototype.isFullscreenInBonusView = function () {
    return mFullscreenInBonusView;
  };

  CAppCtrl.prototype.CheckOrientation = function () {
    return mCheckOrientation;
  };

  CAppCtrl.prototype.setCheckOrientation = function (CheckOrientation) {
    mCheckOrientation = CheckOrientation;
  };

  CAppCtrl.prototype.CheckOrientationInLobby = function () {
    return mCheckOrientationInLobby;
  };

  CAppCtrl.prototype.setCheckOrientationInLobby = function (
    CheckOrientationInLobby
  ) {
    mCheckOrientationInLobby = CheckOrientationInLobby;
  };

  CAppCtrl.prototype.isInLobby = function () {
    return mbIsInLobby;
  };

  CAppCtrl.prototype.setInLobby = function (bIsInLobby) {
    mbIsInLobby = bIsInLobby;
  };

  // CAppCtrl.prototype.fullscreen = function(e)
  // {
  //     mbFullScreen = !mbFullScreen;

  //     if (mbFullScreen == true) {
  //         Utils.enterFullScreen();
  //     }
  //     else {
  //         Utils.exitFullScreen();
  //     }
  //     預防常壓按鈕後跳出下載圖片事件
  //     if(e) e.preventDefault();
  // }

  CAppCtrl.prototype.setCasinoName = function (casinoName) {
    mCasinoName = casinoName;
  };

  CAppCtrl.prototype.getCasinoName = function () {
    return mCasinoName;
  };

  CAppCtrl.prototype.setRegisterNotice = function (registerNotice) {
    mRegisterNotice = registerNotice ? registerNotice.toString() : "";
  };

  CAppCtrl.prototype.getRegisterNotice = function () {
    return mRegisterNotice;
  };

  CAppCtrl.prototype.setPrefix = function (prefix) {
    mPrefix = prefix;
  };

  CAppCtrl.prototype.getPrefix = function () {
    if (!mPrefix) {
      //mPrefix = "W_";
      mPrefix = "";
    }
    return mPrefix;
  };

  CAppCtrl.prototype.setRegisterGM = function (registerGM) {
    mRegisterGM = registerGM;
  };

  CAppCtrl.prototype.getRegisterGM = function () {
    if (!mRegisterGM) {
      mRegisterGM = "WinLobby";
    }
    return mRegisterGM;
  };
  CAppCtrl.prototype.getDebugForbidden = function () {
    return mDebugForbidden;
  };
  CAppCtrl.prototype.setLanguage = function (language) {
    mLanguage = language;
  };

  CAppCtrl.prototype.getLanguage = function () {
    return mLanguage;
  };

  CAppCtrl.prototype.getAccount = function () {
    return mUserInfo ? mUserInfo.Account : null;
  };

  CAppCtrl.prototype.setCookie = function (
    name,
    value //设置cookie
  ) {
    const Days = 100;
    const exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${escape(value)};expires=${exp.toGMTString()}`;
  };

  CAppCtrl.prototype.getCookie = function (
    name //拿到cookie
  ) {
    const reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    const arr = document.cookie.match(reg);
    if (arr) return unescape(arr[2]);
    else return null;
  };

  CAppCtrl.prototype.delCookie = function (
    name //删除cookie
  ) {
    const exp = new Date();
    exp.setTime(exp.getTime() - 1);
    const cval = this.getCookie(name);
    if (cval != null)
      document.cookie = `${name}=${cval};expires=${exp.toGMTString()}`;
  };

  CAppCtrl.prototype.getMachineToken = function () {
    return mMachineToken;
  };

  CAppCtrl.prototype.setMachineTokenCB = function (fn) {
    mMachineTokenCB = fn;
  };

  // CAppCtrl.prototype.closeModal = function () {
  //   const uiModal = document.getElementById("myModal");
  //   if (uiModal) {
  //     const uiModalClose = document.getElementById("modalClose");
  //     if (uiModalClose) uiModalClose.style.display = "";
  //     const uiModalBtns = document.getElementById("modalBtns");
  //     if (uiModalBtns) uiModalBtns.style.display = "none";
  //     mModalConfirmbCBFunc = null;
  //     // hide modal
  //     //uiModal.style.display = "none";
  //     // clear content
  //     const uiModalContent = document.getElementById("modalContent");
  //     if (uiModalContent) {
  //       if (Swal.isLoading()) {
  //         Swal.hideLoading();
  //       }

  //       Swal.close();
  //     }
  //   }
  // };

  CAppCtrl.prototype.sendRequestAction = function (content, target) {
    const obj = new Object();
    obj["From"] = mMiddleServer.deviceName();
    obj["To"] = target;
    obj["Type"] = "Request";
    obj["Content"] = JSON.stringify(content);
    mMiddleServer.invoke(ProtocolCmd.SendAction, JSON.stringify(obj));
  };

  CAppCtrl.prototype.sendResponseAction = function (content, target) {
    if (target !== mMiddleServer.deviceName()) {
      const obj = new Object();
      obj["From"] = mMiddleServer.deviceName();
      obj["To"] = target;
      obj["Type"] = "Request";
      obj["Content"] = JSON.stringify(content);
      // do something
    } else {
      content.status = "success";
      ProceedResponse(mMiddleServer.deviceName(), JSON.stringify(content));
    }
  };

  CAppCtrl.prototype.requestLoginToken = function (
    account,
    password,
    forceLogin,
    fncCB
  ) {
    // skip invalid account/password
    if (!account || !password) return;

    if (fncCB) cbLoginDone = fncCB;

    const obj = new Object();
    obj["request"] = RequestID.GetLoginToken;
    obj["agent"] = null;
    obj["account"] = account;
    obj["password"] = password;
    obj["forceLogin"] = forceLogin ? true : false;
    obj["frontendversion"] = AppCtrl.GetVerCodeRequired();
    obj["verCode"] = "1.0.0.0";
    mMiddleServer.invoke(ProtocolCmd.Request, JSON.stringify(obj));
  };

  CAppCtrl.prototype.requestSync = function (cmd, content) {
    const obj = new Object();
    obj["request"] = RequestID.NotifySync;
    obj["Cmd"] = cmd;
    obj["Content"] = content;
    obj["verCode"] = "1.0.0.0";
    mMiddleServer.invoke(ProtocolCmd.Request, JSON.stringify(obj));
  };

  CAppCtrl.prototype.addLoginInfo = function (apiData, fncCB) {
    if (apiData === void 0) {
      apiData = null;
    }
    if (apiData == null) return;

    cbAddLoginInfoDone = fncCB;

    const obj = new Object();
    obj["request"] = RequestID.AddLoginInfo;
    obj["agent"] = apiData.agent;
    obj["appId"] = apiData.appid;
    obj["token"] = apiData.token;
    obj["lobbyName"] = apiData.lobbyname;
    obj["verCode"] = "1.0.0.0";
    mMiddleServer.invoke(ProtocolCmd.Request, JSON.stringify(obj));
  };

  CAppCtrl.prototype.IncreaseUserCoins = function (apiData, fncCB) {
    if (apiData === void 0) {
      apiData = null;
    }
    if (apiData == null) return;

    cbIncreaseUserCoinsDone = fncCB;

    const obj = new Object();
    obj["request"] = RequestID.IncreaseUserCoins;
    obj["gm"] = apiData.gm;
    obj["account"] = apiData.account;
    obj["coins"] = apiData.coins;
    obj["reason"] = "Bill Acceptor";
    obj["from"] = "Player";
    obj["verCode"] = "1.0.0.0";
    mMiddleServer.invoke(ProtocolCmd.Request, JSON.stringify(obj));
  };

  CAppCtrl.prototype.SubtractUserCoins = function (apiData, fncCB) {
    if (apiData === void 0) {
      apiData = null;
    }
    if (apiData == null) return;

    cbSubtractUserCoinsDone = fncCB;

    const obj = new Object();
    obj["request"] = RequestID.SubtractUserCoins;
    obj["gm"] = apiData.gm;
    obj["account"] = apiData.account;
    obj["coins"] = apiData.coins;
    obj["reason"] = "User Hold CreditOut Button 5 seconds";
    obj["from"] = "Player";
    obj["verCode"] = "1.0.0.0";
    mMiddleServer.invoke(ProtocolCmd.Request, JSON.stringify(obj));
  };

  CAppCtrl.prototype.checkLoginInfo = function (apiData, fncCB) {
    if (apiData === void 0) {
      apiData = null;
    }
    if (apiData == null) {
      return;
    }

    cbCheckLoginInfoDone = fncCB;

    const obj = new Object();
    obj["request"] = RequestID.CheckLoginInfo;
    obj["agent"] = apiData.agent;
    obj["appId"] = apiData.appid;
    obj["verCode"] = "1.0.0.0";
    mMiddleServer.invoke(ProtocolCmd.Request, JSON.stringify(obj));
  };

  CAppCtrl.prototype.changeUserPassword = function (
    account,
    password,
    newPassword
  ) {
    try {
      if (!account) throw new Error(oTextConverter.convert("無效的用戶"));
      if (!password) throw new Error(oTextConverter.convert("密碼錯誤"));
      if (password == newPassword)
        throw new Error(oTextConverter.convert("密碼錯誤"));
      const obj = new Object();
      obj["request"] = RequestID.ChangePassword;
      obj["gm"] = "WinLobby";
      obj["account"] = account;
      obj["password"] = password;
      obj["newPassword"] = newPassword;
      mMiddleServer.invoke(ProtocolCmd.Request, JSON.stringify(obj));
    } catch (err) {
      this.alert(err.message);
    }
  };

  CAppCtrl.prototype.changeUserInfo = function (data) {
    if (mUserInfo && mUserInfo.Account) {
      const obj = new Object();
      obj["request"] = RequestID.ChangeUserInfo;
      obj["gm"] = "WinLobby";
      obj["account"] = mUserInfo.Account;
      obj["data"] = data;
      mMiddleServer.invoke(ProtocolCmd.Request, JSON.stringify(obj));
    } else {
      showAlert({ title: oTextConverter.convert("無效的用戶") });
      this.alert(oTextConverter.convert("無效的用戶"));
    }
  };

  CAppCtrl.prototype.sendMsg = function (content, target) {
    if (target === void 0) {
      target = null;
    }
    if (content.length === 0) return;

    const obj = new Object();
    obj["request"] = RequestID.Chat;
    obj["agent"] = "WinLobby";
    obj["account"] = mUserInfo.Account;
    obj["token"] = mUserInfo.Token;
    obj["target"] = target;
    obj["msg"] = content;
    obj["verCode"] = "1.0.0.0";
    mMiddleServer.invoke(ProtocolCmd.Request, JSON.stringify(obj));
  };

  CAppCtrl.prototype.userTransferCoins = function (coins, target, cbFunc) {
    if (target === void 0) {
      target = null;
    }
    if (target == null || parseFloat(coins) <= 0) {
      showAlert({ title: "請填寫受贈者帳號與贈與的分數" });
      // this.alert("請填寫受贈者帳號與贈與的分數");
      return;
    }

    cbUserTransferCoinsDone = cbFunc;

    const obj = new Object();
    obj["request"] = RequestID.UserTransferCoins;
    obj["account"] = mUserInfo.Account;
    obj["token"] = mUserInfo.Token;
    obj["password"] = this.cachePassword();
    obj["coins"] = coins;
    obj["dest"] = target;
    obj["verCode"] = "1.0.0.0";
    mMiddleServer.invoke(ProtocolCmd.Request, JSON.stringify(obj));
  };

  CAppCtrl.prototype.getUserGiftRecords = function (sTime, eTime, cbFunc) {
    cbGetUserGiftRecordsDone = cbFunc;

    const obj = new Object();
    obj["request"] = RequestID.GetUserGiftRecords;
    obj["account"] = mUserInfo.Account;
    obj["token"] = mUserInfo.Token;
    obj["password"] = this.cachePassword();
    //obj["sTime"] = sTime;
    //obj["eTime"] = eTime;
    obj["sTime"] = `${sTime.getFullYear()}-${
      sTime.getMonth() + 1
    }-${sTime.getDate()} ${sTime.getHours()}:${sTime.getMinutes()}:00`;
    obj["eTime"] = `${eTime.getFullYear()}-${
      eTime.getMonth() + 1
    }-${eTime.getDate()} ${eTime.getHours()}:${eTime.getMinutes()}:00`;
    obj["verCode"] = "1.0.0.0";
    mMiddleServer.invoke(ProtocolCmd.Request, JSON.stringify(obj));
  };

  CAppCtrl.prototype.getScores = function (sTime, eTime, cbFunc) {
    cbGetScoresDone = cbFunc;

    const obj = new Object();
    obj["request"] = RequestID.GetScores;
    obj["account"] = mUserInfo.Account;
    obj["token"] = mUserInfo.Token;
    obj["password"] = this.cachePassword();
    // obj["sTime"] = sTime;
    // obj["eTime"] = eTime;
    obj["sTime"] = `${sTime.getFullYear()}-${
      sTime.getMonth() + 1
    }-${sTime.getDate()} ${sTime.getHours()}:${sTime.getMinutes()}:00`;
    obj["eTime"] = `${eTime.getFullYear()}-${
      eTime.getMonth() + 1
    }-${eTime.getDate()} ${eTime.getHours()}:${eTime.getMinutes()}:00`;
    obj["verCode"] = "1.0.0.0";
    mMiddleServer.invoke(ProtocolCmd.Request, JSON.stringify(obj));
  };

  CAppCtrl.prototype.getUserPlayRecords = function (sTime, eTime, cbFunc) {
    cbGetUserPlayRecordsDone = cbFunc;

    const obj = new Object();
    obj["request"] = RequestID.GetUserPlayRecords;
    obj["account"] = mUserInfo.Account;
    obj["token"] = mUserInfo.Token;
    obj["password"] = this.cachePassword();
    //obj["sTime"] = sTime;
    //obj["eTime"] = eTime;
    obj["sTime"] = `${sTime.getFullYear()}-${
      sTime.getMonth() + 1
    }-${sTime.getDate()} ${sTime.getHours()}:${sTime.getMinutes()}:00`;
    obj["eTime"] = `${eTime.getFullYear()}-${
      eTime.getMonth() + 1
    }-${eTime.getDate()} ${eTime.getHours()}:${eTime.getMinutes()}:00`;
    obj["verCode"] = "1.0.0.0";
    mMiddleServer.invoke(ProtocolCmd.Request, JSON.stringify(obj));
  };

  CAppCtrl.prototype.getUserInfo = function (cbFunc) {
    cbGetUserInfoDone = cbFunc;

    const obj = new Object();
    obj["request"] = RequestID.QueryUser;
    obj["token"] = mUserInfo.Token;
    obj["verCode"] = "1.0.0.0";
    mMiddleServer.invoke(ProtocolCmd.Request, JSON.stringify(obj));
  };

  CAppCtrl.prototype.getBonusBroadcast = function () {
    const obj = new Object();
    obj["request"] = RequestID.GetBonusBroadcast;
    obj["verCode"] = "1.0.0.0";
    mMiddleServer.invoke(ProtocolCmd.Request, JSON.stringify(obj));
  };

  CAppCtrl.prototype.syncLoginToken = function () {
    const account = this.cacheAccount();
    const password = this.cachePassword();
    this.requestLoginToken(account, password, false, null);
  };

  CAppCtrl.prototype.getUserScores = function (cbFunc) {
    cbGetUserScoresDone = cbFunc;

    const obj = new Object();
    obj["request"] = RequestID.QueryScore;
    obj["token"] = mUserInfo.Token;
    obj["verCode"] = "1.0.0.0";
    mMiddleServer.invoke(ProtocolCmd.Request, JSON.stringify(obj));
  };

  CAppCtrl.prototype.getMachineInfos = function (lobbyName, cbFunc) {
    cbGetMachineInfos = cbFunc;

    const obj = new Object();
    obj["request"] = RequestID.MachineInfos;
    obj["roomName"] = lobbyName;
    obj["account"] = mUserInfo.Account;
    obj["token"] = mUserInfo.Token;
    obj["password"] = this.cachePassword();
    obj["verCode"] = "1.0.0.0";
    mMiddleServer.invoke(ProtocolCmd.Request, JSON.stringify(obj));
  };

  CAppCtrl.prototype.exchangeTrialToFormal = function (formalCoins, cbFunc) {
    cbExchangeTrialToFormalDone = cbFunc;

    const mainSettings = this.mainSettings();
    // send request to lobby manager
    const obj = new Object();
    obj["request"] = RequestID.ExchangeTrialToFormal;
    obj["account"] = mUserInfo.Account;
    obj["token"] = mUserInfo.Token;
    obj["coins"] = formalCoins;
    if (mainSettings.hasOwnProperty("ExchangeRatio"))
      obj["ratio"] = parseInt(mainSettings["ExchangeRatio"]);
    if (mainSettings.hasOwnProperty("ExchangeReceiverRate"))
      obj["receiverRate"] = parseInt(mainSettings["ExchangeReceiverRate"]);
    obj["verCode"] = "1.0.0.0";
    mMiddleServer.invoke(ProtocolCmd.Request, JSON.stringify(obj));
  };

  CAppCtrl.prototype.exchangeFormalToTrial = function (formalCoins, cbFunc) {
    cbExchangeFormalToTrialDone = cbFunc;

    const mainSettings = this.mainSettings();
    // send request to lobby manager
    const obj = new Object();
    obj["request"] = RequestID.ExchangeFormalToTrial;
    obj["account"] = mUserInfo.Account;
    obj["token"] = mUserInfo.Token;
    obj["coins"] = formalCoins;
    if (mainSettings.hasOwnProperty("ExchangeRatio"))
      obj["ratio"] = parseInt(mainSettings["ExchangeRatio"]);
    if (mainSettings.hasOwnProperty("ExchangeReceiverRate"))
      obj["receiverRate"] = parseInt(mainSettings["ExchangeReceiverRate"]);
    obj["verCode"] = "1.0.0.0";
    mMiddleServer.invoke(ProtocolCmd.Request, JSON.stringify(obj));
  };

  CAppCtrl.prototype.exchangeBetRewardToFormal = function (
    formalCoins,
    cbFunc
  ) {
    cbExchangeBetRewardToFormalDone = cbFunc;

    // send request to lobby manager
    const obj = new Object();
    obj["request"] = RequestID.ExchangeBetRewardToFormal;
    obj["account"] = mUserInfo.Account;
    obj["token"] = mUserInfo.Token;
    obj["coins"] = formalCoins;
    obj["verCode"] = "1.0.0.0";
    mMiddleServer.invoke(ProtocolCmd.Request, JSON.stringify(obj));
  };

  CAppCtrl.prototype.exchangeUniPlayToFormal = function (formalCoins, cbFunc) {
    cbExchangeUniPlayToFormalDone = cbFunc;

    // send request to lobby manager
    const obj = new Object();
    obj["request"] = RequestID.ExchangeUniPlayToFormal;
    obj["account"] = mUserInfo.Account;
    obj["token"] = mUserInfo.Token;
    obj["coins"] = formalCoins;
    obj["verCode"] = "1.0.0.0";
    mMiddleServer.invoke(ProtocolCmd.Request, JSON.stringify(obj));
  };

  CAppCtrl.prototype.exchangeFormalToUniPlay = function (formalCoins, cbFunc) {
    cbExchangeFormalToUniPlayDone = cbFunc;

    // send request to lobby manager
    const obj = new Object();
    obj["request"] = RequestID.ExchangeFormalToUniPlay;
    obj["account"] = mUserInfo.Account;
    obj["token"] = mUserInfo.Token;
    obj["coins"] = formalCoins;
    obj["verCode"] = "1.0.0.0";
    mMiddleServer.invoke(ProtocolCmd.Request, JSON.stringify(obj));
  };

  CAppCtrl.prototype.startUniPlay = function (
    uniPlayName,
    transferedCoins,
    cbFunc
  ) {
    cbStartUniPlayDone = cbFunc;

    // send request to start uniPlay
    const obj = new Object();
    obj["request"] = RequestID.StartUniPlay;
    obj["account"] = mUserInfo.Account;
    obj["token"] = mUserInfo.Token;
    obj["uniPlayName"] = uniPlayName;
    obj["coins"] = transferedCoins;
    obj["verCode"] = "1.0.0.0";
    mMiddleServer.invoke(ProtocolCmd.Request, JSON.stringify(obj));
  };

  CAppCtrl.prototype.stopUniPlayProcess = function (objResStopUniPlay) {
    return new Promise((resolve) => {
      const status = objResStopUniPlay.status;
      if (status === "success") {
        const userInfo = AppCtrl.userInfo();
        let strScores = userInfo.InCoins - userInfo.OutCoins;
        const scores = parseInt(strScores);

        const finalizeProcess = () => {
          AppCtrl.SetStartUniPlay(false);
          AppCtrl.getUserScores();
          AppCtrl.SetNewLogin(true);
          AppCtrl.getUserInfo(() => {
            AppCtrl.requestLobbies();
            resolve(); // 結束 Promise
          });
        };

        if (scores > 0) {
          AppCtrl.exchangeUniPlayToFormal(scores, (responseObj) => {
            finalizeProcess();
          });
        } else {
          finalizeProcess();
        }
      } else {
        //showAlert({ title: "Error" });
        resolve(); // 失敗仍解決 Promise，避免阻塞
      }
    });
  };

  CAppCtrl.prototype.stopUniPlay = function (cbFunc) {
    cbStopUniPlayDone = cbFunc;

    // send request to start uniPlay
    const obj = new Object();
    obj["request"] = RequestID.StopUniPlay;
    obj["account"] = mUserInfo.Account;
    obj["token"] = mUserInfo.Token;
    obj["verCode"] = "1.0.0.0";
    mMiddleServer.invoke(ProtocolCmd.Request, JSON.stringify(obj));
  };

  CAppCtrl.prototype.requestConfig = function () {
    const obj = new Object();
    mMiddleServer.invoke(ProtocolCmd.RequestConfig, JSON.stringify(obj));
  };

  CAppCtrl.prototype.requestLobbies = function () {
    const obj = new Object();
    mMiddleServer.invoke(ProtocolCmd.RequestLobbies, JSON.stringify(obj));
  };

  CAppCtrl.prototype.requestAtgGames = function () {
    const obj = new Object();
    mMiddleServer.invoke(ProtocolCmd.AtgGames, JSON.stringify(obj));
  };

  CAppCtrl.prototype.requestRsgGames = function () {
    const obj = new Object();
    mMiddleServer.invoke(ProtocolCmd.RsgGames, JSON.stringify(obj));
  };

  CAppCtrl.prototype.requestJoinAtgGames = function (code) {
    const obj = new Object();
    obj["code"] = code;
    obj["account"] = mUserInfo.Account;
    mMiddleServer.invoke(ProtocolCmd.JoinAtgGames, JSON.stringify(obj));
  };

  CAppCtrl.prototype.requestJoinRsgGames = function (gameId) {
    const obj = new Object();
    obj["gameId"] = gameId;
    obj["account"] = mUserInfo.Account;
    mMiddleServer.invoke(ProtocolCmd.JoinRsgGames, JSON.stringify(obj));
  };

  CAppCtrl.prototype.requestLeaveAtgGames = function (_cbLeaveAtgGames) {
    cbLeaveAtgGames = _cbLeaveAtgGames;
    const obj = new Object();
    obj["account"] = mUserInfo.Account;
    mMiddleServer.invoke(ProtocolCmd.LeaveAtgGames, JSON.stringify(obj));
  };

  CAppCtrl.prototype.requestLeaveRsgGames = function (_cbLeaveRsgGames) {
    cbLeaveRsgGames = _cbLeaveRsgGames;
    const obj = new Object();
    obj["account"] = mUserInfo.Account;
    mMiddleServer.invoke(ProtocolCmd.LeaveRsgGames, JSON.stringify(obj));
  };

  CAppCtrl.prototype.requestTopUpToGame = function (_cbRequestTopUpToGame) {
    cbRequestTopUpToGame = _cbRequestTopUpToGame;
    const obj = new Object();
    obj["account"] = mUserInfo.Account;
    mMiddleServer.invoke(ProtocolCmd.RequestTopUpToGame, JSON.stringify(obj));
  };

  CAppCtrl.prototype.joinLobby = function (lobbyName, kickoutPreJoin) {
    const obj = new Object();
    obj["token"] = mUserInfo.Token;
    obj["clientName"] = mMiddleServer.deviceName();
    obj["pinCode"] = lobbyName;
    obj["verCode"] = "1.0.1.5";
    obj["newRoom"] = "false";
    obj["kickoutPreJoin"] = kickoutPreJoin ? true : false;
    mMiddleServer.invoke(ProtocolCmd.Join, JSON.stringify(obj));
  };

  CAppCtrl.prototype.leaveLobby = function () {
    const lobbyName = this.lobbyName();
    if (lobbyName) {
      const obj = new Object();
      obj["clientName"] = mMiddleServer.deviceName();
      obj["pinCode"] = lobbyName;
      obj["verCode"] = "1.0.1.5";
      obj["newRoom"] = "false";
      mMiddleServer.invoke(ProtocolCmd.Leave, JSON.stringify(obj));
      // clear mLobbyName
      mLobbyName = null;
      mLayoutType = LayoutType.Normal;
    }
  };

  CAppCtrl.prototype.lockMachine = function (
    deviceId,
    machineId,
    bLockGuoZhao,
    cbFunc
  ) {
    const lobbyName = this.lobbyName();
    if (!lobbyName) {
      showAlert({ title: "尚未設定遊戲館" });
      // AppCtrl.alert("尚未設定遊戲館");
      return;
    }
    if (deviceId >= 0 && machineId >= 0) {
      fncOnLockMachine = cbFunc;
      // send request to lobby manager
      const obj = new Object();
      obj["Action"] = ActionID.LockMachine;
      obj["ConnectionId"] = mMiddleServer.connectionId();
      obj["User"] = mUserInfo._id;
      obj["LobbyName"] = lobbyName;
      obj["DeviceId"] = deviceId;
      obj["MachineId"] = machineId;
      obj["LockGuoZhao"] = bLockGuoZhao;
      obj["ClientName"] = mMiddleServer.deviceName();
      obj["Device"] = "web";
      AppCtrl.sendRequestAction(obj, RemoteServer.WinLobbyManager);
    } else {
      showAlert({ title: `遊戲館${lobbyName}沒有機台${machineName}` });
      // AppCtrl.alert(`遊戲館${lobbyName}沒有機台${machineName}`);
    }
  };

  CAppCtrl.prototype.unlockMachine = function (bUnlockGuoZhao, cbFunc) {
    if (mLockedMachine) {
      fncOnUnlockMachine = cbFunc;
      // send request to lobby manager
      const obj = new Object();
      obj["Action"] = ActionID.UnlockMachine;
      obj["ConnectionId"] = mMiddleServer.connectionId();
      obj["User"] = mUserInfo._id;
      obj["MachineName"] = mLockedMachine.MachineName;
      obj["LobbyName"] = mLockedMachine.LobbyName;
      obj["DeviceId"] = mLockedMachine.deviceId;
      obj["MachineId"] = mLockedMachine.machineId;
      obj["UnlockGuoZhao"] = bUnlockGuoZhao;
      obj["ClientName"] = mMiddleServer.deviceName();
      this.sendRequestAction(obj, RemoteServer.WinLobbyManager);
    } else {
      console.log("no machine is locked");
    }
  };

  CAppCtrl.prototype.lockSpyMachine = function (machineName, cbFunc) {
    const lobbyName = this.lobbyName();
    if (!lobbyName) {
      showAlert({ title: "尚未設定遊戲館" });
      // AppCtrl.alert("尚未設定遊戲館");
      return;
    }
    const arduinos = mLobbyMachines[lobbyName];
    let deviceId = -1;
    let machineId = -1;
    for (let i = 0; i < arduinos.length; i++) {
      const machines = arduinos[i];
      for (let j = 0; j < machines.length; j++) {
        if (machines[j].MachineName == machineName) {
          deviceId = machines[j].deviceId;
          machineId = machines[j].machineId;
          break;
        }
      }
    }
    if (deviceId != -1 && machineId != -1) {
      fncOnLockSpyMachine = cbFunc;
      // send request to lobby manager
      const obj = new Object();
      obj["Action"] = ActionID.LockSpyMachine;
      obj["ConnectionId"] = mMiddleServer.connectionId();
      obj["User"] = mUserInfo._id;
      obj["LobbyName"] = lobbyName;
      obj["DeviceId"] = deviceId;
      obj["MachineId"] = machineId;
      obj["ClientName"] = mMiddleServer.deviceName();
      obj["Device"] = "web";
      AppCtrl.sendRequestAction(obj, RemoteServer.WinLobbyManager);
    } else {
      showAlert({ title: `遊戲館${lobbyName}沒有機台${machineName}` });
      // AppCtrl.alert(`遊戲館${lobbyName}沒有機台${machineName}`);
    }
  };

  CAppCtrl.prototype.unlockSpyMachine = function (cbFunc) {
    if (mSpyingMachine) {
      fncOnUnlockSpyMachine = cbFunc;
      // send request to lobby manager
      const obj = new Object();
      obj["Action"] = ActionID.UnlockSpyMachine;
      obj["ConnectionId"] = mMiddleServer.connectionId();
      obj["User"] = mUserInfo._id;
      obj["MachineName"] = mSpyingMachine.MachineName;
      obj["LobbyName"] = mSpyingMachine.LobbyName;
      obj["DeviceId"] = mSpyingMachine.deviceId;
      obj["MachineId"] = mSpyingMachine.machineId;
      obj["ClientName"] = mMiddleServer.deviceName();
      this.sendRequestAction(obj, RemoteServer.WinLobbyManager);
    } else {
      console.log("no machine is locked");
    }
  };

  // CAppCtrl.prototype.onModalConfirm = function (btnOKClicked) {
  //   if (mModalConfirmbCBFunc) mModalConfirmbCBFunc(btnOKClicked);
  //   this.closeModal();
  // };

  CAppCtrl.prototype.parseMachineInfos = function (objRes) {
    const userInfo = AppCtrl.userInfo();
    const avatarInfo = userInfo.avatarInfo();
    const guoZhaoInfo = userInfo.guoZhaoInfo();
    const roomId = objRes.RoomID;
    const arrMachineStatusList = objRes.MachineStatus;
    const devicesStatus = new Array();
    const bIsNewLogin = AppCtrl.IsNewLogin();
    const showReservedAsUsed = Config.showReservedAsUsed
      ? Config.showReservedAsUsed
      : false;
    if (
      bIsNewLogin &&
      userInfo.BindedMachines.length > 0 &&
      Config.multiLogin === false
    ) {
      AppCtrl.SetGobackMachine(true);
    } else {
      AppCtrl.SetGobackMachine(false);
    }

    for (let i = 0; i < arrMachineStatusList.length; i++) {
      const machineStatus = new Array();
      const arrMachineStatus = arrMachineStatusList[i];
      for (let j = 0; j < arrMachineStatus.length; j++) {
        let bAddToList = true;

        const obj = arrMachineStatus[j];
        const deviceId = obj.hasOwnProperty("DeviceId")
          ? parseInt(obj.DeviceId)
          : -1;
        const machineId = obj.hasOwnProperty("MachineId")
          ? parseInt(obj.MachineId)
          : -1;
        const spyable = obj.hasOwnProperty("Spyable") ? obj.Spyable : false;
        let user = obj.hasOwnProperty("User") ? obj.User : null;
        const userName = obj.hasOwnProperty("UserName") ? obj.UserName : null;
        let finalizer = obj.hasOwnProperty("Finalizer") ? obj.Finalizer : null;
        const masterMachine = obj.hasOwnProperty("Master") ? obj.Master : true;
        const machineBroken = obj.hasOwnProperty("Broken") ? obj.Broken : false;
        const isGroupGame = obj.hasOwnProperty("IsGroupGame")
          ? obj.IsGroupGame
          : false;
        const gameGroupName = obj.hasOwnProperty("GameGroupName")
          ? obj.GameGroupName
          : "";
        const gameGroupMaxPlayer = obj.hasOwnProperty("GameGroupMaxPlayer")
          ? obj.GameGroupMaxPlayer
          : 0;
        const gameGroupPlayerNo = obj.hasOwnProperty("GameGroupPlayerNo")
          ? obj.GameGroupPlayerNo
          : 0;
        const gameGroupType = obj.hasOwnProperty("GameGroupType")
          ? obj.GameGroupType
          : 0;
        const machineBlocked = obj.hasOwnProperty("Blocked")
          ? obj.Blocked
          : false;
        const oriBlockState = obj.hasOwnProperty("OriBlockState")
          ? obj.Blocked
          : false;
        const machineMaintain = obj.hasOwnProperty("Maintain")
          ? obj.Maintain
          : false;
        const lobbyUsed = obj.hasOwnProperty("LobbyUsed")
          ? obj.LobbyUsed
          : false;
        const bonusType = obj.hasOwnProperty("BonusType") ? obj.BonusType : 0;
        const joinBonus = obj.hasOwnProperty("JoinBonus")
          ? obj.JoinBonus
          : false;
        const winABase = obj.hasOwnProperty("WinABase") ? obj.WinABase : 10;
        const winBBase = obj.hasOwnProperty("WinBBase") ? obj.WinBBase : 10;
        const winAToBonus = obj.hasOwnProperty("WinAToBonus")
          ? obj.WinAToBonus
          : 0;
        const winBToBonus = obj.hasOwnProperty("WinBToBonus")
          ? obj.WinBToBonus
          : 0;
        const trial = obj.hasOwnProperty("Trial") ? obj.Trial : false;
        const guoZhao = obj.hasOwnProperty("GuoZhao") ? obj.GuoZhao : false;
        const inGuoZhao = obj.hasOwnProperty("GuoZhaoIn")
          ? obj.GuoZhaoIn
          : 2000;
        const outGuoZhao = obj.hasOwnProperty("GuoZhaoOut")
          ? obj.GuoZhaoOut
          : 3000;
        const unlockGuoZhao = obj.hasOwnProperty("GuoZhaoUnlock")
          ? obj.GuoZhaoUnlock
          : 10000;
        const guoZhaoUnlockWhenWinAward = obj.hasOwnProperty(
          "GuoZhaoUnlockWhenWinAward"
        )
          ? obj.GuoZhaoUnlockWhenWinAward
          : false;
        let winAward = obj.hasOwnProperty("WinAward") ? obj.WinAward : false;
        const guoZhaoUser = obj.hasOwnProperty("GuoZhaoUser")
          ? obj.GuoZhaoUser
          : null;
        const guoZhaoLeft = obj.hasOwnProperty("GuoZhaoLeft")
          ? obj.GuoZhaoLeft
          : 0;
        const reserved = obj.hasOwnProperty("Reserved") ? obj.Reserved : null;
        const guoZhaoLeftZeroShowNormal = Config.guoZhaoLeftZeroShowNormal
          ? Config.guoZhaoLeftZeroShowNormal
          : false;

        user = user ? user : "";
        finalizer = finalizer ? finalizer : "";

        const machine = new Object();
        machine.status = "";
        machine.LobbyName = roomId;
        machine.guoZhaoLeftZeroShowNormal = false;
        if (guoZhaoLeftZeroShowNormal) {
          if (guoZhaoLeft <= 0 && guoZhao)
            machine.guoZhaoLeftZeroShowNormal = true;
        }
        machine.IsGroupGame = isGroupGame;
        machine.GameGroupName = gameGroupName;
        machine.GameGroupMaxPlayer = gameGroupMaxPlayer;
        machine.GameGroupPlayerNo = gameGroupPlayerNo;
        machine.GameGroupType = gameGroupType;

        if (masterMachine === false) {
          machine.Available = false;
        } else if (deviceId === -1) {
          machine.Available = false;
        } else if (reserved && reserved != mUserInfo.Account) {
          machine.Available = false;
        } else if (avatarInfo && trial) {
          machine.Available = false;
        } else if (guoZhaoUser && guoZhaoUser != mUserInfo.Account) {
          machine.Available = false;
          machine.UserName = guoZhaoUser;
        } else if (user === "") {
          if (finalizer === "" || finalizer === mUserInfo.Account) {
            machine.Available = true;
            if (userName) machine.UserName = userName;
          } else {
            machine.Available = false;
            if (userName) machine.UserName = userName;
          }
        } else if (user === mUserInfo._id) {
          machine.Available = true;
          if (userName) machine.UserName = userName;
        } else {
          machine.Available = false;
        }

        const language = AppCtrl.getLanguage();
        machine.MachineName = obj.hasOwnProperty("MachineName")
          ? obj.MachineName
          : "";

        if (
          lobbyUsed === false &&
          machineBroken === false &&
          machineBlocked === false &&
          machine.Available === true
        ) {
          if (guoZhaoInfo) {
            if (
              guoZhaoInfo.DeviceId == deviceId &&
              guoZhaoInfo.MachineId == machineId
            ) {
              if (language == LANGUAGE_TYPE.en_US) machine.status = "Reguozhao";
              else machine.status = "繼續過招";
            } else {
              if (language == LANGUAGE_TYPE.en_US)
                machine.status = "Guozhao blocked";
              else machine.status = "過招停用";
              // force to disable machine
              machine.Available = false;
            }
          } else {
            if (language == LANGUAGE_TYPE.en_US) machine.status = "Available";
            else machine.status = "可遊玩";

            if (AppCtrl.NeedGobackMachine()) {
              if (
                userInfo.BindedMachines[0].DeviceId != deviceId ||
                userInfo.BindedMachines[0].MachineId != machineId
              ) {
                if (language == LANGUAGE_TYPE.en_US) machine.status = "Closed";
                else machine.status = "請回原機台解除";
                //machine.Available = false;
              }
            }
          }
        } else if (
          lobbyUsed === false &&
          machineBroken === false &&
          machineBlocked === false &&
          machine.Available === false
        ) {
          if (language == LANGUAGE_TYPE.en_US) {
            if (!showReservedAsUsed) {
              if (reserved && reserved != mUserInfo.Account)
                machine.status = "Reserved";
              else machine.status = "Unavailable";
            } else {
              if (reserved && reserved != mUserInfo.Account)
                machine.status = "Unavailable";
              else machine.status = "Unavailable";
            }
          } else {
            if (!showReservedAsUsed) {
              if (reserved && reserved != mUserInfo.Account)
                machine.status = "保留中";
              else machine.status = "使用中";
            } else {
              if (reserved && reserved != mUserInfo.Account)
                machine.status = "使用中";
              else machine.status = "使用中";
            }
          }
        } else {
          if (machineBroken) {
            if (Config.showCloseAsUsed === true) {
              if (language == LANGUAGE_TYPE.en_US)
                machine.status = "Unavailable";
              else machine.status = "使用中";
            } else {
              if (language == LANGUAGE_TYPE.en_US)
                machine.status = "Rosak"; //"Broken";
              else machine.status = "機台故障";
            }
          } else if (lobbyUsed) {
            if (language == LANGUAGE_TYPE.en_US)
              machine.status = "OnSide Player";
            else machine.status = "現場使用中";
          } else {
            if (language == LANGUAGE_TYPE.en_US) machine.status = "Closed";
            else machine.status = "未開放";
            if (AppCtrl.NeedGobackMachine()) {
              if (
                userInfo.BindedMachines[0].DeviceId != deviceId ||
                userInfo.BindedMachines[0].MachineId != machineId
              ) {
                if (language == LANGUAGE_TYPE.en_US) machine.status = "Closed";
                else machine.status = "請回原機台解除";
                //machine.Available = false;
              }
            }
          }
          machine.Available = false;
        }

        if (machineMaintain) {
          if (language == LANGUAGE_TYPE.en_US) machine.status = "Maintain";
          else machine.status = "機台維護中";
        }

        //if(oriBlockState  && machineBroken && masterMachine)
        if (machineBroken && machineBlocked) bAddToList = false;

        if (obj.hasOwnProperty("TypePic")) {
          if (obj.TypePic.indexOf("_h.png") < 0)
            machine.typePic = obj.TypePic.replace(".png", "_h.png");
          else machine.typePic = obj.TypePic;
        }

        machine.deviceId = deviceId;
        machine.machineId = machineId;
        machine.isTrial = trial;
        machine.canSpy = spyable;
        machine.canGuoZhao = guoZhao && !avatarInfo;
        if (guoZhao) {
          machine.inGuoZhaoScore = inGuoZhao;
          machine.outGuoZhaoScore = outGuoZhao;
          machine.unlockGuoZhaoScore = unlockGuoZhao;
          machine.guoZhaoUnlockWhenWinAward = guoZhaoUnlockWhenWinAward;
          machine.winAward = winAward;
        }
        machine.bonusType = bonusType;
        machine.joinBonus = joinBonus;
        machine.winABase = winABase;
        machine.winBBase = winBBase;
        machine.winAToBonus = winAToBonus;
        machine.winBToBonus = winBToBonus;

        if (bAddToList) machineStatus.push(machine);
      }
      devicesStatus.push(machineStatus);
    }
    // add or replace machines for lobby
    const newLobbyMachines = {};
    for (const key in mLobbyMachines) {
      newLobbyMachines[key] = mLobbyMachines[key];
    }
    newLobbyMachines[roomId] = devicesStatus;
    // mLobbyMachines[roomId] = devicesStatus;
    // // refresh mLobbyMachines
    // const newLobbyMachines = {};
    // for (const key in mLobbyMachines) {
    // 	newLobbyMachines[key] = key !== roomId ? mLobbyMachines[key] : devicesStatus;
    // }
    this.setLobbyMachines(newLobbyMachines);
    return newLobbyMachines;
  };

  CAppCtrl.prototype.isUserOnGuoZhao = function () {
    return mbUserOnGuoZhao;
  };

  CAppCtrl.prototype.setCacheAccount = function (cacheAccount) {
    mCacheAccount = cacheAccount;
  };

  CAppCtrl.prototype.cacheAccount = function () {
    return mCacheAccount;
  };

  CAppCtrl.prototype.setCachePassword = function (cachePassword) {
    mCachePassword = cachePassword;
  };

  CAppCtrl.prototype.cachePassword = function () {
    return mCachePassword;
  };

  CAppCtrl.prototype.checkBonusAccount = function () {
    return newBonusAccount == mUserInfo.Account;
  };

  // ====================================================================================
  // private functions
  // ====================================================================================

  function onNotifyJoin(content) {
    const resObj = JSON.parse(content);
    if (resObj.status == "success") {
      //
      mLobbyName = resObj.groupID;
      for (let i = 0; i < mLobbies.length; i++) {
        if (mLobbies[i].name === mLobbyName) {
          mLayoutType = mLobbies[i].layouttype;
        }
      }

      // update userInfo
      if (resObj.hasOwnProperty("token")) mUserInfo.Token = resObj.token;
      if (resObj.hasOwnProperty("InCoins")) mUserInfo.InCoins = resObj.InCoins;
      if (resObj.hasOwnProperty("OutCoins"))
        mUserInfo.OutCoins = resObj.OutCoins;
      if (resObj.hasOwnProperty("InTrialCoins"))
        mUserInfo.InTrialCoins = resObj.InTrialCoins;
      if (resObj.hasOwnProperty("OutTrialCoins"))
        mUserInfo.OutTrialCoins = resObj.OutTrialCoins;
      if (resObj.hasOwnProperty("InUniPlayCoins"))
        mUserInfo.InUniPlayCoins = resObj.InUniPlayCoins;
      if (resObj.hasOwnProperty("OutUniPlayCoins"))
        mUserInfo.OutUniPlayCoins = resObj.OutUniPlayCoins;
      if (resObj.hasOwnProperty("InGuoZhaoCoins"))
        mUserInfo.InGuoZhaoCoins = resObj.InGuoZhaoCoins;
      if (resObj.hasOwnProperty("OutGuoZhaoCoins"))
        mUserInfo.OutGuoZhaoCoins = resObj.OutGuoZhaoCoins;
      if (resObj.hasOwnProperty("BetReward"))
        mUserInfo.BetReward = resObj.BetReward;
      if (resObj.hasOwnProperty("WainZhus"))
        mUserInfo.WainZhus = resObj.WainZhus;
      if (resObj.hasOwnProperty("PaiedAward"))
        mUserInfo.PaiedAward = resObj.PaiedAward;
      if (resObj.hasOwnProperty("InSpecialCoins"))
        mUserInfo.InSpecialCoins = resObj.InSpecialCoins;
      if (resObj.hasOwnProperty("OutSpecialCoins"))
        mUserInfo.OutSpecialCoins = resObj.OutSpecialCoins;
      if (resObj.hasOwnProperty("InSpecialCoinsA"))
        mUserInfo.InSpecialCoinsA = resObj.InSpecialCoinsA;
      if (resObj.hasOwnProperty("OutSpecialCoinsA"))
        mUserInfo.OutSpecialCoinsA = resObj.OutSpecialCoinsA;
      AppCtrl.setUserCoins(
        {
          coins: mUserInfo.InCoins - mUserInfo.OutCoins,
          trialCoins: mUserInfo.InTrialCoins - mUserInfo.OutTrialCoins,
          uniPlayCoins: mUserInfo.InUniPlayCoins - mUserInfo.OutUniPlayCoins,
          guoZhaoCoins: mUserInfo.InGuoZhaoCoins - mUserInfo.OutGuoZhaoCoins,
          betReward: mUserInfo.BetReward,
          wainZhus: mUserInfo.WainZhus,
          specialCoins: mUserInfo.InSpecialCoins - mUserInfo.OutSpecialCoins,
          specialCoinsA: mUserInfo.InSpecialCoinsA - mUserInfo.OutSpecialCoinsA,
        },
        111
      );

      const award = resObj.hasOwnProperty("award") ? resObj.award : null;
      if (award && award.value > 0) {
        let awardMsg = "獎勵贈分: " + award.value + "\r\n已經加入您帳號。";
        //awardMsg += "\r\n請注意每周三\r\n早上8:00到12:00\r\n系統維護無法上線!!!";
        showAlert({ title: awardMsg });
        // AppCtrl.alert(awardMsg);
        console.log(awardMsg);
      }

      // if in main page, switch to lobby page
      const curPage = AppCtrl.curPage();
      console.log(`curPage: ${curPage}`);
      if (curPage == EPage.main) {
        // delay for AppCtrl can receive machine infos
        setTimeout(function () {
          const isMobileDevice = Utils.detectmob();
          AppCtrl.switchPage(EPage.lobby);
          // get machineInfos
          AppCtrl.getMachineInfos(mLobbyName);
        }, 200);
      }

      // if join lobby done, reset heartbeat info
      mMiddleServer.startHeartbeat({
        userInfo: mUserInfo,
        roomId: mLobbyName,
        machine: mLockedMachine,
      });
    } else {
      const language = AppCtrl.getLanguage();
      const message = resObj.hasOwnProperty("message")
        ? resObj["message"].toString()
        : `Login failed`;
      if (message.indexOf("not allow multi-login") >= 0) {
        const obj = JSON.parse(resObj.param);
        const lobbyName = obj.pinCode;
        let title = "";
        let text = "";
        if (language == LANGUAGE_TYPE.en_US) {
          title = "multi-login";
          text = `Lobby ${lobbyName} doesn't support multi login!\nlogout previous device?`;
        } else {
          title = "重複登入";
          text = `遊戲館${lobbyName}不允許重複登入，是否登出前一個連線中的裝置與機台？`;
        }
        //do confirm
        showAlert({
          title,
          text,
          icon: "warning",
          showCancelButton: true,
          confirmCb: function () {
            if (lobbyName) AppCtrl.joinLobby(lobbyName, true);
            else showAlert({ title: message });
          },
        });
        // Swal.fire({
        //   title: title,
        //   text: text,
        //   icon: "warning",
        //   showCancelButton: true,
        //   confirmButtonColor: "#d33",
        //   cancelButtonColor: "#3085d6",
        //   confirmButtonText: "OK",
        //   cancelButtonText: "Cancel",
        // }).then(function (result) {
        //   if (result.isConfirmed) {
        //     if (lobbyName) AppCtrl.joinLobby(lobbyName, true);
        //     else showAlert({ title: message });
        //     // AppCtrl.alert(message);
        //   }
        // });
      } else if (message.indexOf("had join lobby") >= 0) {
        const obj = JSON.parse(resObj.param);
        const userAccount = obj.userAccount;
        const lobbyName = obj.lobbyName;
        const deviceId = obj.deviceId + 1;
        const machineId = obj.machineId + 1;
        const machineName = obj.machineName
          ? obj.machineName
          : `${deviceId}_${machineId}`;
        let text = "";
        if (language == LANGUAGE_TYPE.en_US) {
          text = `${userAccount} is playing machine ${machineName} in Lobby ${lobbyName}.\nPlease go back and unlock it first.`;
        } else {
          text = `${userAccount}正在使用遊戲館${lobbyName}的機台${machineName}。\n請先回原機台解除鎖定。`;
        }
        showAlert({ title: text });
        // AppCtrl.alert(text);
      } else {
        showAlert({ title: message });
        // AppCtrl.alert(message);
      }
    }
  }

  function onNotifyLeave(content) {
    const obj = JSON.parse(content);
    const eventType = obj.hasOwnProperty("Event") ? obj.Event : "LeaveGroup";
    const isCreater = obj.hasOwnProperty("IsCreater")
      ? obj.IsCreater === "true"
      : false;
    const deviceName = obj.hasOwnProperty("deviceName") ? obj.deviceName : "";
    const connectionId = obj.hasOwnProperty("connectionId")
      ? obj.connectionId
      : null;
    const message = obj.hasOwnProperty("message") ? obj.message : null;
    const middleServer = AppCtrl.middleServer();

    if (
      deviceName.indexOf(RemoteServer.WinLobbyManager) >= 0 &&
      deviceName.indexOf(mLobbyName) >= 0
    ) {
      showAlert({ title: `管理程式被關閉，已退出${AppCtrl.lobbyName()}` });
      // AppCtrl.alert(`管理程式被關閉，已退出${AppCtrl.lobbyName()}`);
    } else if (middleServer.connectionId() === connectionId) {
      if (message && message.length > 0) showAlert({ title: message });
      // AppCtrl.alert(message);
    } else {
      const tmpId = middleServer.connectionId();
      console.log(`tmpId:${tmpId}`);
      return;
    }

    console.log("onNotifyLeave");
    mLobbyName = null;
    mLayoutType = LayoutType.Normal;
    // switch to main page
    AppCtrl.switchPage(EPage.main);
    switch (eventType) {
      case "Kickout":
        mLockedMachine = null;
        AppCtrl.middleServer().stop();
        AppCtrl.switchPage(EPage.main);
        break;
      case "LeaveGroup":
        // if join lobby done, reset heartbeat info
        mMiddleServer.startHeartbeat({
          userInfo: mUserInfo,
          roomId: mLobbyName,
          machine: mLockedMachine,
        });
        break;
    }
  }

  function onAction(content) {
    const obj = JSON.parse(content);
    const reqFrom = obj["From"];
    const reqTo = obj["To"];
    if (
      reqTo == mMiddleServer.connectionId() ||
      reqTo == mMiddleServer.deviceName() ||
      reqTo == RemoteServer.WinLobbyAll
    ) {
      const type = obj["Type"];
      const content = obj["Content"];
      switch (type) {
        case "Request":
          ProceedRequest(reqFrom, content);
          break;
        case "Response":
          ProceedResponse(reqFrom, content);
          break;
        default:
          break;
      }
    }
  }

  function onRequest(content) {
    const obj = JSON.parse(content);
    const request = obj.request;
    switch (request) {
      case RequestID.NotifySync:
        const account = obj["Account"];
        const cmd = obj["Cmd"];
        if (account && cmd) {
          switch (cmd) {
            case SyncDataID.SyncGMInfo:
            case SyncDataID.SyncGMScore:
              break;
            case SyncDataID.SyncUserInfo:
              if (mUserInfo.Account == account) {
                // update user info
                AppCtrl.getUserInfo();
              }
              break;
            case SyncDataID.SyncUserScore:
              if (mUserInfo.Account == account) {
                // update user scores
                AppCtrl.getUserScores();
              }
              break;
            case SyncDataID.SyncBonus:
              if (mUserInfo.Account == account) {
                // update user scores
                const content = obj["Content"];
                const audioUrl = "audio/winBonusAudio.wav";
                const audio = new Audio(audioUrl);
                audio.play();

                showAlert({
                  title: "恭喜獲得大獎!!!",
                  text: content,
                  showConfirmButton: true,
                });
              }
              break;
            case SyncDataID.SyncBonusBroadcast:
              newBonusAccount = account;
              const content = obj["Content"];
              const objContent = JSON.parse(content);
              AppCtrl.setBonusBroadcast(objContent);
              break;
            case SyncDataID.SyncToken:
              if (mUserInfo.Account == account) {
                // refresh token
                const newToken = obj["Token"];
                if (mUserInfo.Token !== newToken) {
                  mUserInfo.Token = newToken;
                  // update user info
                  AppCtrl.getUserInfo();
                }
              }
              break;
          }
        }
        break;
    }
  }

  function onResponse(content) {
    const obj = JSON.parse(content);
    const status = obj.status;
    const request = obj.request;
    const language = AppCtrl.getLanguage();

    switch (request) {
      case RequestID.Chat:
        {
          const srcAccount = obj.hasOwnProperty("account")
            ? obj["account"]
            : null;
          const srcNickName = obj.hasOwnProperty("nickName")
            ? obj["nickName"]
            : srcAccount;
          const msg = obj.hasOwnProperty("msg") ? obj["msg"] : null;
          if (srcNickName && msg) {
            const target = obj.hasOwnProperty("target") ? obj["target"] : null;
            // make sure this msg is for current user or broadcast
            if (target === null || target === mUserInfo.Account) {
              onChat(msg, srcNickName);
            }
          }
        }
        break;
      case RequestID.GetLoginToken:
        {
          if (status === "success") {
            mUserInfo.Agent =
              obj.agent && obj.agent.length > 0 ? obj.agent : "WinLobby";
            mUserInfo._id = obj._id;
            mUserInfo.Account = obj.account;
            mUserInfo.NickName = obj.nickName;
            mUserInfo.PhoneNo = obj.phoneNo;
            mUserInfo.GiftEnabled = obj.giftEnabled;
            mUserInfo.Verified =
              obj.hasOwnProperty("verified") && obj["verified"] ? true : false;
            mUserInfo.Blocked =
              obj.hasOwnProperty("blocked") && obj["blocked"] ? true : false;
            mUserInfo.GuoZhaoEnabled =
              obj.hasOwnProperty("guoZhaoEnabled") && obj["guoZhaoEnabled"]
                ? true
                : false;
            mUserInfo.UserUseStoreState =
              obj.hasOwnProperty("userUseStoreState") &&
              obj["userUseStoreState"] === 2
                ? 2
                : 1;
            mUserInfo.Level = obj.hasOwnProperty("level") ? obj.level : "銀卡";
            mUserInfo.MaxBuyableScore = obj.hasOwnProperty("maxPay")
              ? parseInt(obj["maxPay"])
              : 1000000;
            mUserInfo.Token = obj.token;
            // proceed post action of main
            if (cbLoginDone) {
              cbLoginDone({
                status: "success",
                agent: mUserInfo.Agent,
                token: mUserInfo.Token,
                appId: AppCtrl.appId(),
                award: obj.award,
              });
              cbLoginDone = null;
            }

            // if lock machine done, reset heartbeat info
            mMiddleServer.startHeartbeat({
              userInfo: mUserInfo,
              roomId: mLobbyName,
              machine: mLockedMachine,
            });
            // update meta
            const meta = document.querySelector("meta[name=info]");
            if (meta)
              meta.setAttribute(
                "content",
                `connectionId=${mMiddleServer.connectionId()},account=${
                  mUserInfo.Account
                }`
              );
          } else if (curPage == EPage.main) {
            if (cbLoginDone) {
              cbLoginDone({
                status: "failed",
                error: obj.error,
              });
              cbLoginDone = null;
            }
          }
        }
        break;
      case RequestID.SubtractUserCoins:
        if (cbSubtractUserCoinsDone) {
          if (obj.status === "success") {
            cbSubtractUserCoinsDone({ status: "success" });
          } else {
            cbSubtractUserCoinsDone({ status: "fail" });
          }
          cbSubtractUserCoinsDone = null;
        }
        break;
      case RequestID.IncreaseUserCoins:
        if (cbIncreaseUserCoinsDone) {
          if (obj.status === "success") {
            cbIncreaseUserCoinsDone({ status: "success" });
          } else {
            cbIncreaseUserCoinsDone({ status: "fail" });
          }
          cbIncreaseUserCoinsDone = null;
        }
        break;
      case RequestID.AddLoginInfo:
        if (cbAddLoginInfoDone) {
          cbAddLoginInfoDone(obj);
          cbAddLoginInfoDone = null;
        }
        break;
      case RequestID.CheckLoginInfo:
        if (cbCheckLoginInfoDone) {
          cbCheckLoginInfoDone(obj);
          cbCheckLoginInfoDone = null;
        }
        break;
      case RequestID.UserTransferCoins:
        AppCtrl.getUserScores();
        // proceed and clear callback
        if (cbUserTransferCoinsDone) {
          cbUserTransferCoinsDone(obj);
          cbUserTransferCoinsDone = null;
        }
        break;
      case RequestID.GetUserGiftRecords:
        // proceed and clear callback
        if (cbGetUserGiftRecordsDone) {
          cbGetUserGiftRecordsDone(obj);
          cbGetUserGiftRecordsDone = null;
        }
        break;
      case RequestID.GetScores:
        // proceed and clear callback
        if (cbGetScoresDone) {
          cbGetScoresDone(obj);
          cbGetScoresDone = null;
        }
        break;
      case RequestID.GetUserPlayRecords:
        // proceed and clear callback
        if (cbGetUserPlayRecordsDone) {
          cbGetUserPlayRecordsDone(obj);
          cbGetUserPlayRecordsDone = null;
        }
        break;
      case RequestID.QueryUser:
        {
          if (obj.hasOwnProperty("UserInfo")) {
            const strUserInfo = obj["UserInfo"].toString();
            const objUserInfo = JSON.parse(strUserInfo);
            const userAccount = objUserInfo.hasOwnProperty("Account")
              ? objUserInfo["Account"].toString()
              : null;
            // if account matched, update user info
            if (userAccount == mUserInfo.Account) {
              if (objUserInfo.hasOwnProperty("Permission")) {
                const newPermission = parseInt(
                  objUserInfo["Permission"].toString()
                );
                if (mUserInfo.Permission != newPermission) {
                  // if permission changed, update user's level info
                  if (objUserInfo.hasOwnProperty("level"))
                    mUserInfo.Level = objUserInfo.level.toString();
                  if (objUserInfo.hasOwnProperty("maxPay"))
                    mUserInfo.MaxBuyableScore = parseInt(objUserInfo["maxPay"]);
                  mUserInfo.Permission = newPermission;
                }
              }
              if (
                objUserInfo.hasOwnProperty("Password") &&
                userAccount == AppCtrl.cacheAccount()
              ) {
                AppCtrl.setCachePassword(objUserInfo["Password"].toString());
              }
              if (objUserInfo.hasOwnProperty("NickName"))
                mUserInfo.NickName = objUserInfo["NickName"].toString();
              if (objUserInfo.hasOwnProperty("Token"))
                mUserInfo.Token = objUserInfo["Token"].toString();
              if (objUserInfo.hasOwnProperty("UniPlayInfo")) {
                const strUniPlayInfo = objUserInfo["UniPlayInfo"]
                  ? objUserInfo["UniPlayInfo"].toString()
                  : "";
                if (strUniPlayInfo.length > 0) {
                  const objUniPlayInfo = JSON.parse(strUniPlayInfo);
                  mUserInfo.UniPlayInfo =
                    Object.keys(objUniPlayInfo).length > 0
                      ? objUniPlayInfo
                      : null;
                }
              }
              if (objUserInfo.hasOwnProperty("AvatarInfo")) {
                const strAvatarInfo = objUserInfo["AvatarInfo"]
                  ? objUserInfo["AvatarInfo"].toString()
                  : "";
                if (strAvatarInfo.length > 0) {
                  const objAvatarInfo = JSON.parse(strAvatarInfo);
                  mUserInfo.AvatarInfo =
                    Object.keys(objAvatarInfo).length > 0
                      ? objAvatarInfo
                      : null;
                } else mUserInfo.AvatarInfo = null;
              }
              if (objUserInfo.hasOwnProperty("PhoneNo"))
                mUserInfo.PhoneNo = objUserInfo["PhoneNo"].toString();
              if (objUserInfo.hasOwnProperty("GiftEnabled"))
                mUserInfo.GiftEnabled = objUserInfo["GiftEnabled"]
                  ? true
                  : false;
              if (objUserInfo.hasOwnProperty("Verified"))
                mUserInfo.Verified = objUserInfo["Verified"] ? true : false;
              if (objUserInfo.hasOwnProperty("GuoZhaoEnabled"))
                mUserInfo.GuoZhaoEnabled = objUserInfo["GuoZhaoEnabled"]
                  ? true
                  : false;
              if (objUserInfo.hasOwnProperty("userUseStoreState"))
                mUserInfo.UserUseStoreState =
                  objUserInfo["userUseStoreState"] === 2 ? 2 : 1;
              if (objUserInfo.hasOwnProperty("Blocked"))
                mUserInfo.Blocked = objUserInfo["Blocked"] ? true : false;
              if (objUserInfo.hasOwnProperty("GuoZhaoInfo")) {
                const strGuoZhao = objUserInfo["GuoZhaoInfo"].toString();
                mUserInfo.parseGuoZhaoInfo(strGuoZhao);
              }
              if (objUserInfo.hasOwnProperty("InCoins"))
                mUserInfo.InCoins = parseFloat(
                  objUserInfo["InCoins"].toString()
                );
              if (objUserInfo.hasOwnProperty("OutCoins"))
                mUserInfo.OutCoins = parseFloat(
                  objUserInfo["OutCoins"].toString()
                );
              if (objUserInfo.hasOwnProperty("InTrialCoins"))
                mUserInfo.InTrialCoins = parseFloat(
                  objUserInfo["InTrialCoins"].toString()
                );
              if (objUserInfo.hasOwnProperty("OutTrialCoins"))
                mUserInfo.OutTrialCoins = parseFloat(
                  objUserInfo["OutTrialCoins"].toString()
                );
              if (objUserInfo.hasOwnProperty("InUniPlayCoins"))
                mUserInfo.InUniPlayCoins = parseFloat(
                  objUserInfo["InUniPlayCoins"].toString()
                );
              if (objUserInfo.hasOwnProperty("OutUniPlayCoins"))
                mUserInfo.OutUniPlayCoins = parseFloat(
                  objUserInfo["OutUniPlayCoins"].toString()
                );
              if (objUserInfo.hasOwnProperty("InGuoZhaoCoins"))
                mUserInfo.InGuoZhaoCoins = parseFloat(
                  objUserInfo["InGuoZhaoCoins"].toString()
                );
              if (objUserInfo.hasOwnProperty("OutGuoZhaoCoins"))
                mUserInfo.OutGuoZhaoCoins = parseFloat(
                  objUserInfo["OutGuoZhaoCoins"].toString()
                );
              if (objUserInfo.hasOwnProperty("BetReward"))
                mUserInfo.BetReward = parseFloat(
                  objUserInfo["BetReward"].toString()
                );
              if (objUserInfo.hasOwnProperty("WainZhus"))
                mUserInfo.WainZhus = parseInt(
                  objUserInfo["WainZhus"].toString()
                );
              if (objUserInfo.hasOwnProperty("PaiedAward"))
                mUserInfo.PaiedAward = parseInt(
                  objUserInfo["PaiedAward"].toString()
                );
              if (objUserInfo.hasOwnProperty("InSpecialCoins"))
                mUserInfo.InSpecialCoins = parseFloat(
                  objUserInfo["InSpecialCoins"].toString()
                );
              if (objUserInfo.hasOwnProperty("OutSpecialCoins"))
                mUserInfo.OutSpecialCoins = parseFloat(
                  objUserInfo["OutSpecialCoins"].toString()
                );
              if (objUserInfo.hasOwnProperty("InSpecialCoinsA"))
                mUserInfo.InSpecialCoinsA = parseFloat(
                  objUserInfo["InSpecialCoinsA"].toString()
                );
              if (objUserInfo.hasOwnProperty("OutSpecialCoinsA"))
                mUserInfo.OutSpecialCoinsA = parseFloat(
                  objUserInfo["OutSpecialCoinsA"].toString()
                );
              if (objUserInfo.hasOwnProperty("BindedMachines")) {
                const bindedMachines = [];
                const strBindedMachines =
                  objUserInfo["BindedMachines"].toString();
                if (strBindedMachines.length > 0) {
                  const arrContent = JSON.parse(strBindedMachines);
                  arrContent.forEach((objBindedMachine) => {
                    bindedMachines.push(objBindedMachine);
                  });
                }
                mUserInfo.BindedMachines = bindedMachines;
              }
              AppCtrl.setUserCoins(
                {
                  coins: mUserInfo.InCoins - mUserInfo.OutCoins,
                  trialCoins: mUserInfo.InTrialCoins - mUserInfo.OutTrialCoins,
                  uniPlayCoins:
                    mUserInfo.InUniPlayCoins - mUserInfo.OutUniPlayCoins,
                  guoZhaoCoins:
                    mUserInfo.InGuoZhaoCoins - mUserInfo.OutGuoZhaoCoins,
                  betReward: mUserInfo.BetReward,
                  wainZhus: mUserInfo.WainZhus,
                  specialCoins:
                    mUserInfo.InSpecialCoins - mUserInfo.OutSpecialCoins,
                  specialCoinsA:
                    mUserInfo.InSpecialCoinsA - mUserInfo.OutSpecialCoinsA,
                },
                222
              );
              AppCtrl.setGuoZhao(mUserInfo.GuoZhaoInfo);
            }
          } else {
            // resync user's token
            AppCtrl.syncLoginToken();
          }
          // proceed and clear callback
          if (cbGetUserInfoDone) {
            cbGetUserInfoDone(obj);
            cbGetUserInfoDone = null;
          }
        }
        break;
      case RequestID.QueryScore:
        {
          const status = obj.hasOwnProperty("status")
            ? obj["status"].toString()
            : "failed";
          if (status === "success") {
            if (obj.hasOwnProperty("inCoins"))
              mUserInfo.InCoins = parseFloat(obj["inCoins"].toString());
            if (obj.hasOwnProperty("outCoins"))
              mUserInfo.OutCoins = parseFloat(obj["outCoins"].toString());
            if (obj.hasOwnProperty("inTrialCoins"))
              mUserInfo.InTrialCoins = parseFloat(
                obj["inTrialCoins"].toString()
              );
            if (obj.hasOwnProperty("outTrialCoins"))
              mUserInfo.OutTrialCoins = parseFloat(
                obj["outTrialCoins"].toString()
              );
            if (obj.hasOwnProperty("inUniPlayCoins"))
              mUserInfo.InUniPlayCoins = parseFloat(
                obj["inUniPlayCoins"].toString()
              );
            if (obj.hasOwnProperty("outUniPlayCoins"))
              mUserInfo.OutUniPlayCoins = parseFloat(
                obj["outUniPlayCoins"].toString()
              );
            if (obj.hasOwnProperty("inGuoZhaoCoins"))
              mUserInfo.InGuoZhaoCoins = parseFloat(
                obj["inGuoZhaoCoins"].toString()
              );
            if (obj.hasOwnProperty("outGuoZhaoCoins"))
              mUserInfo.OutGuoZhaoCoins = parseFloat(
                obj["outGuoZhaoCoins"].toString()
              );
            if (obj.hasOwnProperty("betReward"))
              mUserInfo.BetReward = parseFloat(obj["betReward"].toString());
            if (obj.hasOwnProperty("wainZhus"))
              mUserInfo.WainZhus = parseInt(obj["wainZhus"].toString());
            if (obj.hasOwnProperty("paiedAward"))
              mUserInfo.PaiedAward = parseInt(obj["paiedAward"].toString());
            if (obj.hasOwnProperty("inSpecialCoins"))
              mUserInfo.InSpecialCoins = parseFloat(
                obj["inSpecialCoins"].toString()
              );
            if (obj.hasOwnProperty("outSpecialCoins"))
              mUserInfo.OutSpecialCoins = parseFloat(
                obj["outSpecialCoins"].toString()
              );
            if (obj.hasOwnProperty("inSpecialCoinsA"))
              mUserInfo.InSpecialCoinsA = parseFloat(
                obj["inSpecialCoinsA"].toString()
              );
            if (obj.hasOwnProperty("outSpecialCoinsA"))
              mUserInfo.OutSpecialCoinsA = parseFloat(
                obj["outSpecialCoinsA"].toString()
              );
            AppCtrl.setUserCoins(
              {
                coins: mUserInfo.InCoins - mUserInfo.OutCoins,
                trialCoins: mUserInfo.InTrialCoins - mUserInfo.OutTrialCoins,
                uniPlayCoins:
                  mUserInfo.InUniPlayCoins - mUserInfo.OutUniPlayCoins,
                guoZhaoCoins:
                  mUserInfo.InGuoZhaoCoins - mUserInfo.OutGuoZhaoCoins,
                betReward: mUserInfo.BetReward,
                wainZhus: mUserInfo.WainZhus,
                specialCoins:
                  mUserInfo.InSpecialCoins - mUserInfo.OutSpecialCoins,
                specialCoinsA:
                  mUserInfo.InSpecialCoinsA - mUserInfo.OutSpecialCoinsA,
              },
              333
            );
          } else {
            // refresh user's token
            AppCtrl.syncLoginToken();
          }
          // proceed and clear callback
          if (cbGetUserScoresDone) {
            cbGetUserScoresDone(obj);
            cbGetUserScoresDone = null;
          }
        }
        break;
      case RequestID.MachineInfos:
        {
          const lobbyMachines = AppCtrl.parseMachineInfos(obj);
          AppCtrl.setLobbyMachines(lobbyMachines);
          // proceed and clear callback
          if (cbGetMachineInfos) {
            cbGetMachineInfos(obj);
            cbGetMachineInfos = null;
          }
        }
        break;
      case RequestID.GetBroadcasts:
        if (status === "success" && !mStartUniPlay) {
          mBroadcastMsgs = obj.hasOwnProperty("broadcasts")
            ? obj["broadcasts"]
            : [];
          AppCtrl.setBroadcastMsgs(mBroadcastMsgs);
        }
        break;
      case RequestID.ExchangeTrialToFormal:
        {
          if (status === "success") {
            if (obj.hasOwnProperty("InCoins"))
              mUserInfo.InCoins = parseFloat(obj["InCoins"].toString());
            if (obj.hasOwnProperty("OutCoins"))
              mUserInfo.OutCoins = parseFloat(obj["OutCoins"].toString());
            if (obj.hasOwnProperty("InTrialCoins"))
              mUserInfo.InTrialCoins = parseFloat(
                obj["InTrialCoins"].toString()
              );
            if (obj.hasOwnProperty("OutTrialCoins"))
              mUserInfo.OutTrialCoins = parseFloat(
                obj["OutTrialCoins"].toString()
              );
            if (obj.hasOwnProperty("InUniPlayCoins"))
              mUserInfo.InUniPlayCoins = parseFloat(
                obj["InUniPlayCoins"].toString()
              );
            if (obj.hasOwnProperty("OutUniPlayCoins"))
              mUserInfo.OutUniPlayCoins = parseFloat(
                obj["OutUniPlayCoins"].toString()
              );
            if (obj.hasOwnProperty("InGuoZhaoCoins"))
              mUserInfo.InGuoZhaoCoins = parseFloat(
                obj["InGuoZhaoCoins"].toString()
              );
            if (obj.hasOwnProperty("OutGuoZhaoCoins"))
              mUserInfo.OutGuoZhaoCoins = parseFloat(
                obj["OutGuoZhaoCoins"].toString()
              );
            if (obj.hasOwnProperty("BetReward"))
              mUserInfo.BetReward = parseFloat(obj["BetReward"].toString());
            if (obj.hasOwnProperty("WainZhus"))
              mUserInfo.WainZhus = parseInt(obj["WainZhus"].toString());
            if (obj.hasOwnProperty("paiedAward"))
              mUserInfo.PaiedAward = parseInt(obj["paiedAward"].toString());
            if (obj.hasOwnProperty("InSpecialCoins"))
              mUserInfo.InSpecialCoins = parseFloat(
                obj["InSpecialCoins"].toString()
              );
            if (obj.hasOwnProperty("OutSpecialCoins"))
              mUserInfo.OutSpecialCoins = parseFloat(
                obj["OutSpecialCoins"].toString()
              );
            if (obj.hasOwnProperty("InSpecialCoinsA"))
              mUserInfo.InSpecialCoinsA = parseFloat(
                obj["InSpecialCoinsA"].toString()
              );
            if (obj.hasOwnProperty("OutSpecialCoinsA"))
              mUserInfo.OutSpecialCoinsA = parseFloat(
                obj["OutSpecialCoinsA"].toString()
              );
            AppCtrl.setUserCoins(
              {
                coins: mUserInfo.InCoins - mUserInfo.OutCoins,
                trialCoins: mUserInfo.InTrialCoins - mUserInfo.OutTrialCoins,
                uniPlayCoins:
                  mUserInfo.InUniPlayCoins - mUserInfo.OutUniPlayCoins,
                guoZhaoCoins:
                  mUserInfo.InGuoZhaoCoins - mUserInfo.OutGuoZhaoCoins,
                betReward: mUserInfo.BetReward,
                wainZhus: mUserInfo.WainZhus,
                specialCoins:
                  mUserInfo.InSpecialCoins - mUserInfo.OutSpecialCoins,
                specialCoinsA:
                  mUserInfo.InSpecialCoinsA - mUserInfo.OutSpecialCoinsA,
              },
              444
            );
          }
          if (cbExchangeTrialToFormalDone) {
            cbExchangeTrialToFormalDone(obj);
            cbExchangeTrialToFormalDone = null;
          }
        }
        break;
      case RequestID.ExchangeFormalToTrial:
        {
          if (status === "success") {
            if (obj.hasOwnProperty("InCoins"))
              mUserInfo.InCoins = parseFloat(obj["InCoins"].toString());
            if (obj.hasOwnProperty("OutCoins"))
              mUserInfo.OutCoins = parseFloat(obj["OutCoins"].toString());
            if (obj.hasOwnProperty("InTrialCoins"))
              mUserInfo.InTrialCoins = parseFloat(
                obj["InTrialCoins"].toString()
              );
            if (obj.hasOwnProperty("OutTrialCoins"))
              mUserInfo.OutTrialCoins = parseFloat(
                obj["OutTrialCoins"].toString()
              );
            if (obj.hasOwnProperty("InUniPlayCoins"))
              mUserInfo.InUniPlayCoins = parseFloat(
                obj["InUniPlayCoins"].toString()
              );
            if (obj.hasOwnProperty("OutUniPlayCoins"))
              mUserInfo.OutUniPlayCoins = parseFloat(
                obj["OutUniPlayCoins"].toString()
              );
            if (obj.hasOwnProperty("InGuoZhaoCoins"))
              mUserInfo.InGuoZhaoCoins = parseFloat(
                obj["InGuoZhaoCoins"].toString()
              );
            if (obj.hasOwnProperty("OutGuoZhaoCoins"))
              mUserInfo.OutGuoZhaoCoins = parseFloat(
                obj["OutGuoZhaoCoins"].toString()
              );
            if (obj.hasOwnProperty("BetReward"))
              mUserInfo.BetReward = parseFloat(obj["BetReward"].toString());
            if (obj.hasOwnProperty("WainZhus"))
              mUserInfo.WainZhus = parseInt(obj["WainZhus"].toString());
            if (obj.hasOwnProperty("paiedAward"))
              mUserInfo.PaiedAward = parseInt(obj["paiedAward"].toString());
            if (obj.hasOwnProperty("InSpecialCoins"))
              mUserInfo.InSpecialCoins = parseFloat(
                obj["InSpecialCoins"].toString()
              );
            if (obj.hasOwnProperty("OutSpecialCoins"))
              mUserInfo.OutSpecialCoins = parseFloat(
                obj["OutSpecialCoins"].toString()
              );
            if (obj.hasOwnProperty("InSpecialCoinsA"))
              mUserInfo.InSpecialCoinsA = parseFloat(
                obj["InSpecialCoinsA"].toString()
              );
            if (obj.hasOwnProperty("OutSpecialCoinsA"))
              mUserInfo.OutSpecialCoinsA = parseFloat(
                obj["OutSpecialCoinsA"].toString()
              );
            AppCtrl.setUserCoins(
              {
                coins: mUserInfo.InCoins - mUserInfo.OutCoins,
                trialCoins: mUserInfo.InTrialCoins - mUserInfo.OutTrialCoins,
                uniPlayCoins:
                  mUserInfo.InUniPlayCoins - mUserInfo.OutUniPlayCoins,
                guoZhaoCoins:
                  mUserInfo.InGuoZhaoCoins - mUserInfo.OutGuoZhaoCoins,
                betReward: mUserInfo.BetReward,
                wainZhus: mUserInfo.WainZhus,
                specialCoins:
                  mUserInfo.InSpecialCoins - mUserInfo.OutSpecialCoins,
                specialCoinsA:
                  mUserInfo.InSpecialCoinsA - mUserInfo.OutSpecialCoinsA,
              },
              555
            );
          }
          if (cbExchangeFormalToTrialDone) {
            cbExchangeFormalToTrialDone(obj);
            cbExchangeFormalToTrialDone = null;
          }
        }
        break;
      case RequestID.ExchangeBetRewardToFormal:
        {
          if (status === "success") {
            if (obj.hasOwnProperty("InCoins"))
              mUserInfo.InCoins = parseFloat(obj["InCoins"].toString());
            if (obj.hasOwnProperty("OutCoins"))
              mUserInfo.OutCoins = parseFloat(obj["OutCoins"].toString());
            if (obj.hasOwnProperty("InTrialCoins"))
              mUserInfo.InTrialCoins = parseFloat(
                obj["InTrialCoins"].toString()
              );
            if (obj.hasOwnProperty("OutTrialCoins"))
              mUserInfo.OutTrialCoins = parseFloat(
                obj["OutTrialCoins"].toString()
              );
            if (obj.hasOwnProperty("InUniPlayCoins"))
              mUserInfo.InUniPlayCoins = parseFloat(
                obj["InUniPlayCoins"].toString()
              );
            if (obj.hasOwnProperty("OutUniPlayCoins"))
              mUserInfo.OutUniPlayCoins = parseFloat(
                obj["OutUniPlayCoins"].toString()
              );
            if (obj.hasOwnProperty("InGuoZhaoCoins"))
              mUserInfo.InGuoZhaoCoins = parseFloat(
                obj["InGuoZhaoCoins"].toString()
              );
            if (obj.hasOwnProperty("OutGuoZhaoCoins"))
              mUserInfo.OutGuoZhaoCoins = parseFloat(
                obj["OutGuoZhaoCoins"].toString()
              );
            if (obj.hasOwnProperty("BetReward"))
              mUserInfo.BetReward = parseFloat(obj["BetReward"].toString());
            if (obj.hasOwnProperty("WainZhus"))
              mUserInfo.WainZhus = parseInt(obj["WainZhus"].toString());
            if (obj.hasOwnProperty("paiedAward"))
              mUserInfo.PaiedAward = parseInt(obj["paiedAward"].toString());
            if (obj.hasOwnProperty("InSpecialCoins"))
              mUserInfo.InSpecialCoins = parseFloat(
                obj["InSpecialCoins"].toString()
              );
            if (obj.hasOwnProperty("OutSpecialCoins"))
              mUserInfo.OutSpecialCoins = parseFloat(
                obj["OutSpecialCoins"].toString()
              );
            if (obj.hasOwnProperty("InSpecialCoinsA"))
              mUserInfo.InSpecialCoinsA = parseFloat(
                obj["InSpecialCoinsA"].toString()
              );
            if (obj.hasOwnProperty("OutSpecialCoinsA"))
              mUserInfo.OutSpecialCoinsA = parseFloat(
                obj["OutSpecialCoinsA"].toString()
              );
            AppCtrl.setUserCoins(
              {
                coins: mUserInfo.InCoins - mUserInfo.OutCoins,
                trialCoins: mUserInfo.InTrialCoins - mUserInfo.OutTrialCoins,
                uniPlayCoins:
                  mUserInfo.InUniPlayCoins - mUserInfo.OutUniPlayCoins,
                guoZhaoCoins:
                  mUserInfo.InGuoZhaoCoins - mUserInfo.OutGuoZhaoCoins,
                betReward: mUserInfo.BetReward,
                wainZhus: mUserInfo.WainZhus,
                specialCoins:
                  mUserInfo.InSpecialCoins - mUserInfo.OutSpecialCoins,
                specialCoinsA:
                  mUserInfo.InSpecialCoinsA - mUserInfo.OutSpecialCoinsA,
              },
              666
            );
          }
          if (cbExchangeBetRewardToFormalDone) {
            cbExchangeBetRewardToFormalDone(obj);
            cbExchangeBetRewardToFormalDone = null;
          }
        }
        break;
      case RequestID.ExchangeUniPlayToFormal:
        {
          if (status === "success") {
            if (obj.hasOwnProperty("InCoins"))
              mUserInfo.InCoins = parseFloat(obj["InCoins"].toString());
            if (obj.hasOwnProperty("OutCoins"))
              mUserInfo.OutCoins = parseFloat(obj["OutCoins"].toString());
            if (obj.hasOwnProperty("InTrialCoins"))
              mUserInfo.InTrialCoins = parseFloat(
                obj["InTrialCoins"].toString()
              );
            if (obj.hasOwnProperty("OutTrialCoins"))
              mUserInfo.OutTrialCoins = parseFloat(
                obj["OutTrialCoins"].toString()
              );
            if (obj.hasOwnProperty("InUniPlayCoins"))
              mUserInfo.InUniPlayCoins = parseFloat(
                obj["InUniPlayCoins"].toString()
              );
            if (obj.hasOwnProperty("OutUniPlayCoins"))
              mUserInfo.OutUniPlayCoins = parseFloat(
                obj["OutUniPlayCoins"].toString()
              );
            if (obj.hasOwnProperty("InGuoZhaoCoins"))
              mUserInfo.InGuoZhaoCoins = parseFloat(
                obj["InGuoZhaoCoins"].toString()
              );
            if (obj.hasOwnProperty("OutGuoZhaoCoins"))
              mUserInfo.OutGuoZhaoCoins = parseFloat(
                obj["OutGuoZhaoCoins"].toString()
              );
            if (obj.hasOwnProperty("BetReward"))
              mUserInfo.BetReward = parseFloat(obj["BetReward"].toString());
            if (obj.hasOwnProperty("WainZhus"))
              mUserInfo.WainZhus = parseInt(obj["WainZhus"].toString());
            if (obj.hasOwnProperty("paiedAward"))
              mUserInfo.PaiedAward = parseInt(obj["paiedAward"].toString());
            if (obj.hasOwnProperty("InSpecialCoins"))
              mUserInfo.InSpecialCoins = parseFloat(
                obj["InSpecialCoins"].toString()
              );
            if (obj.hasOwnProperty("OutSpecialCoins"))
              mUserInfo.OutSpecialCoins = parseFloat(
                obj["OutSpecialCoins"].toString()
              );
            if (obj.hasOwnProperty("InSpecialCoinsA"))
              mUserInfo.InSpecialCoinsA = parseFloat(
                obj["InSpecialCoinsA"].toString()
              );
            if (obj.hasOwnProperty("OutSpecialCoinsA"))
              mUserInfo.OutSpecialCoinsA = parseFloat(
                obj["OutSpecialCoinsA"].toString()
              );
            AppCtrl.setUserCoins(
              {
                coins: mUserInfo.InCoins - mUserInfo.OutCoins,
                trialCoins: mUserInfo.InTrialCoins - mUserInfo.OutTrialCoins,
                uniPlayCoins:
                  mUserInfo.InUniPlayCoins - mUserInfo.OutUniPlayCoins,
                guoZhaoCoins:
                  mUserInfo.InGuoZhaoCoins - mUserInfo.OutGuoZhaoCoins,
                betReward: mUserInfo.BetReward,
                wainZhus: mUserInfo.WainZhus,
                specialCoins:
                  mUserInfo.InSpecialCoins - mUserInfo.OutSpecialCoins,
                specialCoinsA:
                  mUserInfo.InSpecialCoinsA - mUserInfo.OutSpecialCoinsA,
              },
              777
            );
          } else {
            const err = obj.error;
            if (language == LANGUAGE_TYPE.zh_TW) {
              showAlert({ title: "轉換幣不足或有誤" });
            } else {
              showAlert({ title: err ? err : "轉換幣不足或有誤" });
            }
          }
          if (cbExchangeUniPlayToFormalDone) {
            cbExchangeUniPlayToFormalDone(obj);
            cbExchangeUniPlayToFormalDone = null;
          }
        }
        break;
      case RequestID.ExchangeFormalToUniPlay:
        {
          if (status === "success") {
            if (obj.hasOwnProperty("InCoins"))
              mUserInfo.InCoins = parseFloat(obj["InCoins"].toString());
            if (obj.hasOwnProperty("OutCoins"))
              mUserInfo.OutCoins = parseFloat(obj["OutCoins"].toString());
            if (obj.hasOwnProperty("InTrialCoins"))
              mUserInfo.InTrialCoins = parseFloat(
                obj["InTrialCoins"].toString()
              );
            if (obj.hasOwnProperty("OutTrialCoins"))
              mUserInfo.OutTrialCoins = parseFloat(
                obj["OutTrialCoins"].toString()
              );
            if (obj.hasOwnProperty("InUniPlayCoins"))
              mUserInfo.InUniPlayCoins = parseFloat(
                obj["InUniPlayCoins"].toString()
              );
            if (obj.hasOwnProperty("OutUniPlayCoins"))
              mUserInfo.OutUniPlayCoins = parseFloat(
                obj["OutUniPlayCoins"].toString()
              );
            if (obj.hasOwnProperty("InGuoZhaoCoins"))
              mUserInfo.InGuoZhaoCoins = parseFloat(
                obj["InGuoZhaoCoins"].toString()
              );
            if (obj.hasOwnProperty("OutGuoZhaoCoins"))
              mUserInfo.OutGuoZhaoCoins = parseFloat(
                obj["OutGuoZhaoCoins"].toString()
              );
            if (obj.hasOwnProperty("BetReward"))
              mUserInfo.BetReward = parseFloat(obj["BetReward"].toString());
            if (obj.hasOwnProperty("WainZhus"))
              mUserInfo.WainZhus = parseInt(obj["WainZhus"].toString());
            if (obj.hasOwnProperty("paiedAward"))
              mUserInfo.PaiedAward = parseInt(obj["paiedAward"].toString());
            if (obj.hasOwnProperty("InSpecialCoins"))
              mUserInfo.InSpecialCoins = parseFloat(
                obj["InSpecialCoins"].toString()
              );
            if (obj.hasOwnProperty("OutSpecialCoins"))
              mUserInfo.OutSpecialCoins = parseFloat(
                obj["OutSpecialCoins"].toString()
              );
            if (obj.hasOwnProperty("InSpecialCoinsA"))
              mUserInfo.InSpecialCoinsA = parseFloat(
                obj["InSpecialCoinsA"].toString()
              );
            if (obj.hasOwnProperty("OutSpecialCoinsA"))
              mUserInfo.OutSpecialCoinsA = parseFloat(
                obj["OutSpecialCoinsA"].toString()
              );
            AppCtrl.setUserCoins(
              {
                coins: mUserInfo.InCoins - mUserInfo.OutCoins,
                trialCoins: mUserInfo.InTrialCoins - mUserInfo.OutTrialCoins,
                uniPlayCoins:
                  mUserInfo.InUniPlayCoins - mUserInfo.OutUniPlayCoins,
                guoZhaoCoins:
                  mUserInfo.InGuoZhaoCoins - mUserInfo.OutGuoZhaoCoins,
                betReward: mUserInfo.BetReward,
                wainZhus: mUserInfo.WainZhus,
                specialCoins:
                  mUserInfo.InSpecialCoins - mUserInfo.OutSpecialCoins,
                specialCoinsA:
                  mUserInfo.InSpecialCoinsA - mUserInfo.OutSpecialCoinsA,
              },
              888
            );
          } else {
            const err = obj.error;
            if (language == LANGUAGE_TYPE.zh_TW) {
              showAlert({ title: "轉換幣不足或有誤" });
            } else {
              showAlert({ title: err ? err : "轉換幣不足或有誤" });
            }
          }
          if (cbExchangeFormalToUniPlayDone) {
            cbExchangeFormalToUniPlayDone(obj);
            cbExchangeFormalToUniPlayDone = null;
          }
        }
        break;
      case RequestID.StartUniPlay:
        {
          if (status === "success") {
            mStartUniPlay = true;
            const { Domain, Account, Password } = obj.uniPlay;
            AppCtrl.connectToServer(Domain, function () {
              AppCtrl.requestConfig();
              //send request token
              AppCtrl.requestLoginToken(
                Account,
                Password,
                true,
                function (objRes) {
                  cbStartUniPlayDone(objRes);
                  cbStartUniPlayDone = null;
                }
              );
            });
          } else {
            if (cbStartUniPlayDone) {
              cbStartUniPlayDone(obj);
              cbStartUniPlayDone = null;
            }
          }
        }
        break;
      case RequestID.StopUniPlay:
        {
          if (status === "success") {
            // update user info
            AppCtrl.getUserInfo();
          }
          if (cbStopUniPlayDone) {
            cbStopUniPlayDone(obj);
            cbStopUniPlayDone = null;
          }
        }
        break;
      case RequestID.CheckConnectState:
        {
          if (status === "success") {
            const objUserInfo = obj["userInfo"];
            const objMachineInfo = obj["machineInfo"];
          } else {
            const err = obj.error;
            showAlert({ title: err ? err : "unable to get connected state" });
            // AppCtrl.alert(err ? err : "unable to get connected state");
          }
        }
        break;
      case RequestID.KickoutRemoteClient:
        {
          const msg = obj.hasOwnProperty("message")
            ? obj["message"]
            : "已被系統登出";
          if (msg && msg.length > 0) showAlert({ title: msg });
          // AppCtrl.alert(msg);
          mLobbyName = null;
          mLockedMachine = null;
          mLayoutType = LayoutType.Normal;
          AppCtrl.middleServer().stop();
          AppCtrl.switchPage(EPage.main);
        }
        break;
      case RequestID.KickoutGuoZhao:
        {
          const gm = obj.hasOwnProperty("gm") ? obj["gm"] : null;
          const account = obj.hasOwnProperty("account") ? obj["account"] : null;
          const lobby = obj.hasOwnProperty("lobby") ? obj["lobby"] : null;
          if (account == mUserInfo.Account) {
            // requery machineInfos in lobby
            AppCtrl.getMachineInfos(lobby, (objs) => {
              const lobbyMachines = AppCtrl.parseMachineInfos(objs);
              AppCtrl.setLobbyMachines(lobbyMachines);
            });
            // popup alert
            let msg;
            if (language == LANGUAGE_TYPE.en_US) {
              msg = `GM ${gm} uses ${lobby} to stop your GuoZhao.`;
            } else {
              msg = `管理者${gm}從${lobby}停止您的開招。`;
            }
            showAlert({ title: msg });
            // AppCtrl.alert(msg);
          }
        }
        break;
      case RequestID.NotifySync:
        break;
      case RequestID.GateServerCloseClient:
        {
          let msg;
          if (language == LANGUAGE_TYPE.en_US) {
            msg = "System Closed right now, please play the game late!";
          } else {
            msg = "系統已經關閉, 請待系統重啟完成再繼續遊戲,謝謝!";
          }
          showAlert({ title: msg });
          // AppCtrl.alert(msg);
          mLobbyName = null;
          mLockedMachine = null;
          mLayoutType = LayoutType.Normal;
          AppCtrl.middleServer().stop();
          AppCtrl.switchPage(EPage.main);
        }
        break;
      case RequestID.GateServerCloseManager:
        break;
      case RequestID.GateServerNoticeCloseClient:
        {
          let msg;
          if (language == LANGUAGE_TYPE.en_US) {
            msg =
              "Whole System will be closed, please keyout the score and exit the game.";
          } else {
            msg = "系統即將關閉請盡快進行洗分並退出遊戲";
          }
          showAlert({ title: msg });
          // AppCtrl.alert(msg);
        }
        break;
      case RequestID.GetUnknownOutScore:
      case RequestID.RecordUnknownOutScore:
      case RequestID.BookMachine:
      case RequestID.UnbookMachine:
      case RequestID.PayBookMachines:
        break;
      case RequestID.GetBonusBroadcast:
        {
          const content = obj["listContent"];
          const objContent = JSON.parse(content);
          AppCtrl.setBonusBroadcast(objContent);
        }
        break;
      case RequestID.MachineToken:
        {
          if (status === "success") {
            // to verify machine token
            const apiCommand = `${document.location.origin}/APIs/VerifyMachineToken.ashx`;
            const apiData = {
              lobby: AppCtrl.isMachineTokenInLobby()
                ? AppCtrl.GetDefaultLobbyName()
                : AppCtrl.lobbyName(),
              connectionId: AppCtrl.middleServer().connectionId(),
              account: AppCtrl.getAccount(),
              token: obj["token"].toString(),
            };
            fetch(apiCommand, {
              body: JSON.stringify(apiData),
              headers: {
                "user-agent": "Mozilla/4.0 MDN Example",
                "content-type": "application/json",
              },
              method: "POST", // *GET, POST, PUT, DELETE, etc.
              mode: "cors", // no-cors, cors, *same-origin
              redirect: "follow", // manual, *follow, error
              referrer: "no-referrer", // *client, no-referrer
            })
              .then(function (response) {
                return response.json();
              })
              .then(function (data) {
                if (data.ResultCode !== "OK")
                  throw new Error("failed to get server ip & port");
                mMachineToken = obj["token"];
                if (mMachineTokenCB) {
                  mMachineTokenCB();
                  mMachineTokenCB = null;
                }
              })
              .catch(function (err) {
                console.log(err.message ? err.message : err);
              });
          } else {
            const errMsg = obj.hasOwnProperty("error")
              ? obj["error"]
              : "unknown error";
            console.log(errMsg);
          }
        }
        break;
    }
  }

  function onConnectionStatus(content) {
    console.log(`onConnectionStatus:${content}`);
    if (mMiddleServer) mMiddleServer.clearHeartbeatAckTimeout();
  }

  function onNotifyConfig(content) {
    const data = JSON.parse(content);
    if (data.hasOwnProperty("mainSettings")) {
      mMainSettings.parse(data.mainSettings);
    }
  }

  function onNotifyLobbies(content) {
    const data = JSON.parse(content);
    if (data.message == "success") {
      const roomsInfo = data.roomsInfo;
      if (roomsInfo) {
        const arrGroups = new Array();
        for (let i = 0; i < roomsInfo.length; i++) {
          const info = roomsInfo[i];
          const roomName = info.roomName;
          const urlBgImage = info.urlBgImage;
          const layoutType = info.LayoutType
            ? info.LayoutType
            : LayoutType.Normal;

          arrGroups.push({
            name: roomName,
            bgimg: urlBgImage,
            layouttype: layoutType,
          });
        }
        AppCtrl.setLobbyInfos(arrGroups);
        //AppCtrl.askMachineTokenInLobby();
      }
    } else {
      AppCtrl.setLobbyInfos([]);
      showAlert({ title: data.message });
      // AppCtrl.alert(data.message);
    }
  }

  function onNotifyAtgGames(content) {
    const data = JSON.parse(content);
    if (data.message == "success") {
      const atgGames = data.roomsInfo;
      fncSetAtgGames(atgGames);
    } else {
      fncSetAtgGames([]);
      showAlert({ title: data.message });
    }
  }

  function onNotifyRsgGames(content) {
    const data = JSON.parse(content);
    if (data.message == "success") {
      const rsgGames = data.roomsInfo;
      fncSetRsgGames(rsgGames);
    } else {
      fncSetRsgGames([]);
      showAlert({ title: data.message });
    }
  }

  function onNotifyJoinAtgGames(content) {
    const data = JSON.parse(content);
    if (data.message == "success") {
      const atgGameUrl = data.url;
      fncSetAtgGameUrl(atgGameUrl);
    } else {
      fncSetAtgGameUrl("");
      AppCtrl.switchPage(EPage.main);
      showAlert({ title: data.message });
    }
  }

  function onNotifyJoinRsgGames(content) {
    const data = JSON.parse(content);
    if (data.message == "success") {
      const rsgGameUrl = data.url;
      fncSetRsgGameUrl(rsgGameUrl);
    } else {
      fncSetRsgGameUrl("");
      AppCtrl.switchPage(EPage.main);
      showAlert({ title: data.message });
    }
  }

  function onNotifyLeaveAtgGames(content) {
    const data = JSON.parse(content);
    if (data.message == "success") {
      fncSetAtgGameUrl("");
      if (cbLeaveAtgGames) cbLeaveAtgGames();
      cbLeaveAtgGames = null;
    }
  }

  function onNotifyLeaveRsgGames(content) {
    const data = JSON.parse(content);
    if (data.message == "success") {
      fncSetRsgGameUrl("");
      if (cbLeaveRsgGames) cbLeaveRsgGames();
      cbLeaveRsgGames = null;
    }
  }

  function onRequestTopUpToGame(content) {
    const data = JSON.parse(content);
    if (data.message === "success") {
      showAlert({ title: "點數已上分成功" });
    } else {
      showAlert({ title: data.message });
    }
    if (cbRequestTopUpToGame) cbRequestTopUpToGame(data.message === "success");
  }

  function onChat(msg, from) {
    const uiChatHistory = document.getElementById("chatHistory");
    if (uiChatHistory) {
      // push msg to history...
      mChatHistory.push({
        user: from,
        msg: msg,
      });
      // show msg...
      let maxMsgCnt = 50;
      let beginIndex =
        mChatHistory.length > maxMsgCnt ? mChatHistory.length - maxMsgCnt : 0;
      let chatContent = "";
      for (let i = beginIndex; i < mChatHistory.length; i++) {
        chatContent += `${mChatHistory[i].user}: ${mChatHistory[i].msg}\n`;
      }
      uiChatHistory.value = chatContent;
    }
  }

  function onLockMachine(objRes) {
    if (objRes.status == "success") {
      const viewType =
        objRes.hasOwnProperty("GameUI") && objRes.GameUI.hasOwnProperty("view")
          ? objRes.GameUI["view"]
          : UILayout.Unknown;

      mMachineInfo.parse(objRes);
      const roomId = mMachineInfo.roomId;
      const deviceId = mMachineInfo.deviceId;
      const machineId = mMachineInfo.machineId;
      const devices = mLobbyMachines[roomId];
      const machines = devices[deviceId];

      mbUserOnGuoZhao = objRes.hasOwnProperty("GuoZhaoWallet")
        ? objRes["GuoZhaoWallet"]
        : false;

      if (mUserInfo.Token !== null) {
        if (objRes.hasOwnProperty("InCoins"))
          mUserInfo.InCoins = parseFloat(objRes["InCoins"].toString());
        if (objRes.hasOwnProperty("OutCoins"))
          mUserInfo.OutCoins = parseFloat(objRes["OutCoins"].toString());
        if (objRes.hasOwnProperty("InTrialCoins"))
          mUserInfo.InTrialCoins = parseFloat(
            objRes["InTrialCoins"].toString()
          );
        if (objRes.hasOwnProperty("OutTrialCoins"))
          mUserInfo.OutTrialCoins = parseFloat(
            objRes["OutTrialCoins"].toString()
          );
        if (objRes.hasOwnProperty("InUniPlayCoins"))
          mUserInfo.InUniPlayCoins = parseFloat(
            objRes["InUniPlayCoins"].toString()
          );
        if (objRes.hasOwnProperty("OutUniPlayCoins"))
          mUserInfo.OutUniPlayCoins = parseFloat(
            objRes["OutUniPlayCoins"].toString()
          );
        if (objRes.hasOwnProperty("InGuoZhaoCoins"))
          mUserInfo.InGuoZhaoCoins = parseFloat(
            objRes["InGuoZhaoCoins"].toString()
          );
        if (objRes.hasOwnProperty("OutGuoZhaoCoins"))
          mUserInfo.OutGuoZhaoCoins = parseFloat(
            objRes["OutGuoZhaoCoins"].toString()
          );
        if (objRes.hasOwnProperty("BetReward"))
          mUserInfo.BetReward = parseFloat(objRes["BetReward"].toString());
        if (objRes.hasOwnProperty("WainZhus"))
          mUserInfo.WainZhus = parseInt(objRes["WainZhus"].toString());
        if (objRes.hasOwnProperty("PaiedAward"))
          mUserInfo.PaiedAward = parseInt(objRes["PaiedAward"].toString());
        if (objRes.hasOwnProperty("InSpecialCoins"))
          mUserInfo.InSpecialCoins = parseFloat(
            objRes["InSpecialCoins"].toString()
          );
        if (objRes.hasOwnProperty("OutSpecialCoins"))
          mUserInfo.OutSpecialCoins = parseFloat(
            objRes["OutSpecialCoins"].toString()
          );
        if (objRes.hasOwnProperty("InSpecialCoinsA"))
          mUserInfo.InSpecialCoinsA = parseFloat(
            objRes["InSpecialCoinsA"].toString()
          );
        if (objRes.hasOwnProperty("OutSpecialCoinsA"))
          mUserInfo.OutSpecialCoinsA = parseFloat(
            objRes["OutSpecialCoinsA"].toString()
          );

        AppCtrl.setUserCoins(
          {
            coins: mUserInfo.InCoins - mUserInfo.OutCoins,
            trialCoins: mUserInfo.InTrialCoins - mUserInfo.OutTrialCoins,
            uniPlayCoins: mUserInfo.InUniPlayCoins - mUserInfo.OutUniPlayCoins,
            guoZhaoCoins: mUserInfo.InGuoZhaoCoins - mUserInfo.OutGuoZhaoCoins,
            betReward: mUserInfo.BetReward,
            wainZhus: mUserInfo.WainZhus,
            specialCoins: mUserInfo.InSpecialCoins - mUserInfo.OutSpecialCoins,
            specialCoinsA:
              mUserInfo.InSpecialCoinsA - mUserInfo.OutSpecialCoinsA,
          },
          666
        );
      }

      // locate machine
      mLockedMachine = null;
      for (let i = 0; i < machines.length; i++) {
        if (machines[i].machineId == machineId) {
          mLockedMachine = machines[i];
          break;
        }
      }
      if (objRes.hasOwnProperty("Gameplay")) {
        const objGameplay = objRes["Gameplay"];
        AppCtrl.setGameplay(objGameplay);
      }

      if (fncOnLockMachine) {
        fncOnLockMachine(objRes);
      } else {
        switch (viewType) {
          case UILayout.Classic:
            AppCtrl.switchPage(EPage.playClassic);
            break;
          case UILayout.Baccarat:
            AppCtrl.switchPage(EPage.playBJ);
            break;
          default:
            AppCtrl.switchPage(EPage.playClassic);
            break;
        }
      }

      if (Config.fullScreenLockMachine === true) Utils.enterFullScreen();

      // if lock machine done, reset heartbeat info
      mMiddleServer.startHeartbeat({
        userInfo: mUserInfo,
        roomId: mLobbyName,
        machine: mLockedMachine,
      });
      AppCtrl.SetNewLogin(false);
      AppCtrl.SetGobackMachine(false);
      // leon: request MachineToken
      const obj = new Object();
      mMachineToken = null;
      obj["request"] = RequestID.MachineToken;
      obj["lobby"] = AppCtrl.lobbyName();
      obj["connectionId"] = AppCtrl.middleServer().connectionId();
      obj["account"] = AppCtrl.getAccount();
      mMiddleServer.invoke(ProtocolCmd.Request, JSON.stringify(obj));
    } else {
      if (fncOnLockMachine) {
        fncOnLockMachine(objRes);
      } else {
        let errMsg = objRes.message !== null ? objRes.message : "未知的錯誤";
        if (errMsg.search("現場使用中") != -1) {
          errMsg = "機台忙碌中請稍後再點選或者選擇其他機台,謝謝!";
        }
        showAlert({ title: errMsg });
        // AppCtrl.alert(errMsg);
      }
    }
    // clear callback
    fncOnLockMachine = null;
  }

  function onUnlockMachine(objRes) {
    if (objRes.status == "success") {
      mMachineInfo.reset();
      mbUserOnGuoZhao = false;
      mLockedMachine = null;

      if (fncOnUnlockMachine) fncOnUnlockMachine(objRes);
      else AppCtrl.switchPage(EPage.lobby);
      // clear msg
      AppCtrl.setScoreMsg("");
      // if unlock machine done, reset heartbeat info
      mMiddleServer.startHeartbeat({
        userInfo: mUserInfo,
        roomId: mLobbyName,
        machine: mLockedMachine,
      });
    } else {
      const errMsg = objRes.message !== null ? objRes.message : "未知的錯誤";
      showAlert({ title: `onUnlockMachine:${errMsg}` });
      // AppCtrl.alert(`onUnlockMachine:${errMsg}`);
    }
    // clear callback
    fncOnUnlockMachine = null;
    AppCtrl.SetNewLogin(false);
    AppCtrl.SetGobackMachine(false);
    AppCtrl.setBetWinData([]);
    AppCtrl.setBonusState([]);
  }

  function onLockSpyMachine(objRes) {
    if (objRes.status == "success") {
      if (Config.fullScreenLockMachine === true) Utils.enterFullScreen();
      mSpyMachineInfo.parse(objRes);
      const roomId = mSpyMachineInfo.roomId;
      const deviceId = mSpyMachineInfo.deviceId;
      const machineId = mSpyMachineInfo.machineId;
      const devicesStatus = mLobbyMachines[roomId];
      const machines = devicesStatus[deviceId];
      // locate machine
      mSpyingMachine = null;
      for (let i = 0; i < machines.length; i++) {
        if (machines[i].machineId == machineId) {
          mSpyingMachine = machines[i];
          break;
        }
      }

      if (fncOnLockSpyMachine) {
        fncOnLockSpyMachine(objRes);
      } else {
        const viewType = objRes.hasOwnProperty("view")
          ? objRes["view"]
          : UILayout.Unknown;
        switch (viewType) {
          case UILayout.Classic:
            AppCtrl.switchPage(EPage.spyClassic);
            break;
          case UILayout.Baccarat:
            AppCtrl.switchPage(EPage.spyClassic);
            break;
          default:
            AppCtrl.switchPage(EPage.spyClassic);
            break;
        }
      }
    } else {
      const errMsg = objRes.message !== null ? objRes.message : "未知的錯誤";
      showAlert({ title: `onLockSpyMachine:${errMsg}` });
      // AppCtrl.alert(`onLockSpyMachine:${errMsg}`);
    }
    // clear callback
    fncOnLockSpyMachine = null;
  }

  function onUnlockSpyMachine(objRes) {
    if (objRes.status == "success") {
      //Utils.exitFullscreen();
      mSpyMachineInfo.reset();
      mSpyingMachine = null;

      if (fncOnUnlockSpyMachine) fncOnUnlockSpyMachine(objRes);
      else AppCtrl.switchPage(EPage.lobby);
      // clear msg
      AppCtrl.setScoreMsg("");
    } else {
      const errMsg = objRes.message !== null ? objRes.message : "未知的錯誤";
      showAlert({ title: `onUnlockSpyMachine:${errMsg}` });
      // AppCtrl.alert(`onUnlockSpyMachine:${errMsg}`);
    }
    // clear callback
    fncOnUnlockSpyMachine = null;
    AppCtrl.setBetWinData([]);
    AppCtrl.setBonusState([]);
  }

  function onGameBtnDown(objRes) {
    const deviceId = objRes.hasOwnProperty("DeviceId")
      ? parseInt(objRes["DeviceId"])
      : -1;
    const machineId = objRes.hasOwnProperty("MachineId")
      ? parseInt(objRes["MachineId"])
      : -1;
    if (
      objRes.hasOwnProperty("BtnId") &&
      mLockedMachine &&
      mLockedMachine.deviceId == deviceId &&
      mLockedMachine.machineId == machineId
    ) {
      const btnTypes = mMachineInfo.btnTypes;
      const gameUI = mMachineInfo.gameUI;
      if (btnTypes && gameUI) {
        const btnId = objRes.BtnId;
        const btnType = btnTypes[btnId];
        // if btnType is none zero, show server's response down/up state
        if (btnType > 0 && gameUI.gamebtns) {
          const uiBtn = gameUI.gamebtns[btnId];
          console.log(`server response btn id=${uiBtn.id} down`);
        }
      }
    }
  }

  function onGameBtnUp(objRes) {
    const deviceId = objRes.hasOwnProperty("DeviceId")
      ? parseInt(objRes["DeviceId"])
      : -1;
    const machineId = objRes.hasOwnProperty("MachineId")
      ? parseInt(objRes["MachineId"])
      : -1;
    if (
      objRes.hasOwnProperty("BtnId") &&
      mLockedMachine &&
      mLockedMachine.deviceId == deviceId &&
      mLockedMachine.machineId == machineId
    ) {
      const btnTypes = mMachineInfo.btnTypes;
      const gameUI = mMachineInfo.gameUI;
      if (btnTypes && gameUI) {
        const btnId = objRes.BtnId;
        const btnType = btnTypes[btnId];
        // if btnType is none zero, show server's response down/up state
        if (btnType > 0 && gameUI.gamebtns) {
          const uiBtn = gameUI.gamebtns[btnId];
          console.log(`server response btn id=${uiBtn.id} up`);
        }
      }
    }
  }

  function onUpdateScore(objRes) {
    const inCoins = objRes.hasOwnProperty("InCoins")
      ? parseFloat(objRes["InCoins"].toString())
      : mUserInfo.InCoins;
    const outCoins = objRes.hasOwnProperty("OutCoins")
      ? parseFloat(objRes["OutCoins"].toString())
      : mUserInfo.OutCoins;
    const inTrialCoins = objRes.hasOwnProperty("InTrialCoins")
      ? parseFloat(objRes["InTrialCoins"].toString())
      : mUserInfo.InTrialCoins;
    const outTrialCoins = objRes.hasOwnProperty("OutTrialCoins")
      ? parseFloat(objRes["OutTrialCoins"].toString())
      : mUserInfo.OutTrialCoins;
    const inUniPlayCoins = objRes.hasOwnProperty("InUniPlayCoins")
      ? parseFloat(objRes["InUniPlayCoins"].toString())
      : mUserInfo.InUniPlayCoins;
    const outUniPlayCoins = objRes.hasOwnProperty("OutUniPlayCoins")
      ? parseFloat(objRes["OutUniPlayCoins"].toString())
      : mUserInfo.OutUniPlayCoins;
    const inGuoZhaoCoins = objRes.hasOwnProperty("InGuoZhaoCoins")
      ? parseFloat(objRes["InGuoZhaoCoins"].toString())
      : mUserInfo.InGuoZhaoCoins;
    const outGuoZhaoCoins = objRes.hasOwnProperty("OutGuoZhaoCoins")
      ? parseFloat(objRes["OutGuoZhaoCoins"].toString())
      : mUserInfo.OutGuoZhaoCoins;
    const betReward = objRes.hasOwnProperty("BetReward")
      ? parseFloat(objRes["BetReward"].toString())
      : mUserInfo.BetReward;
    const wainZhus = objRes.hasOwnProperty("WainZhus")
      ? parseInt(objRes["WainZhus"].toString())
      : mUserInfo.WainZhus;
    const paiedAward = objRes.hasOwnProperty("PaiedAward")
      ? parseInt(objRes["PaiedAward"].toString())
      : mUserInfo.PaiedAward;
    const inSpecialCoins = objRes.hasOwnProperty("InSpecialCoins")
      ? parseFloat(objRes["InSpecialCoins"].toString())
      : mUserInfo.InSpecialCoins;
    const outSpecialCoins = objRes.hasOwnProperty("OutSpecialCoins")
      ? parseFloat(objRes["OutSpecialCoins"].toString())
      : mUserInfo.OutSpecialCoins;
    const inSpecialCoinsA = objRes.hasOwnProperty("InSpecialCoinsA")
      ? parseFloat(objRes["InSpecialCoinsA"].toString())
      : mUserInfo.InSpecialCoinsA;
    const outSpecialCoinsA = objRes.hasOwnProperty("OutSpecialCoinsA")
      ? parseFloat(objRes["OutSpecialCoinsA"].toString())
      : mUserInfo.OutSpecialCoinsA;
    if (
      inCoins !== mUserInfo.InCoins ||
      outCoins !== mUserInfo.OutCoins ||
      inTrialCoins != mUserInfo.InTrialCoins ||
      outTrialCoins != mUserInfo.OutTrialCoins ||
      inUniPlayCoins !== mUserInfo.InUniPlayCoins ||
      outUniPlayCoins !== mUserInfo.OutUniPlayCoins ||
      inGuoZhaoCoins != mUserInfo.InGuoZhaoCoins ||
      outGuoZhaoCoins != mUserInfo.OutGuoZhaoCoins ||
      wainZhus != mUserInfo.WainZhus ||
      paiedAward != mUserInfo.PaiedAward ||
      inSpecialCoins != mUserInfo.InSpecialCoins ||
      outSpecialCoins != mUserInfo.OutSpecialCoins ||
      inSpecialCoinsA != mUserInfo.InSpecialCoinsA ||
      outSpecialCoinsA != mUserInfo.OutSpecialCoinsA
    ) {
      mUserInfo.InCoins = inCoins;
      mUserInfo.OutCoins = outCoins;
      mUserInfo.InTrialCoins = inTrialCoins;
      mUserInfo.OutTrialCoins = outTrialCoins;
      mUserInfo.InUniPlayCoins = inUniPlayCoins;
      mUserInfo.OutUniPlayCoins = outUniPlayCoins;
      mUserInfo.InGuoZhaoCoins = inGuoZhaoCoins;
      mUserInfo.OutGuoZhaoCoins = outGuoZhaoCoins;
      mUserInfo.BetReward = betReward;
      mUserInfo.WainZhus = wainZhus;
      mUserInfo.PaiedAward = paiedAward;
      mUserInfo.InSpecialCoins = inSpecialCoins;
      mUserInfo.OutSpecialCoins = outSpecialCoins;
      mUserInfo.InSpecialCoinsA = inSpecialCoinsA;
      mUserInfo.OutSpecialCoinsA = outSpecialCoinsA;
      AppCtrl.setUserCoins(
        {
          coins: mUserInfo.InCoins - mUserInfo.OutCoins,
          trialCoins: mUserInfo.InTrialCoins - mUserInfo.OutTrialCoins,
          uniPlayCoins: mUserInfo.InUniPlayCoins - mUserInfo.OutUniPlayCoins,
          guoZhaoCoins: mUserInfo.InGuoZhaoCoins - mUserInfo.OutGuoZhaoCoins,
          betReward: mUserInfo.BetReward,
          wainZhus: mUserInfo.WainZhus,
          specialCoins: mUserInfo.InSpecialCoins - mUserInfo.OutSpecialCoins,
          specialCoinsA: mUserInfo.InSpecialCoinsA - mUserInfo.OutSpecialCoinsA,
        },
        777
      );
    }

    if (objRes.hasOwnProperty("Gameplay")) {
      const objGameplay = objRes["Gameplay"];
      AppCtrl.setGameplay(objGameplay);
    }

    if (objRes.hasOwnProperty("message")) {
      const objMessage = objRes["message"];
      AppCtrl.setScoreMsg(objMessage);
    }
  }

  function ProceedRequest(from, content) {}

  function ProceedResponse(from, content) {
    const objRes = JSON.parse(content);
    const token = objRes.hasOwnProperty("Token")
      ? objRes["Token"].toString()
      : null;
    const action = objRes.hasOwnProperty("Action")
      ? objRes["Action"].toString()
      : ActionID.None;
    const connectionId = objRes.hasOwnProperty("ConnectionId")
      ? objRes["ConnectionId"].toString()
      : "";
    const lobbyName = objRes.hasOwnProperty("LobbyName")
      ? objRes["LobbyName"].toString()
      : null;
    const deviceId = objRes.hasOwnProperty("DeviceId")
      ? parseInt(objRes["DeviceId"])
      : -1;
    const machineId = objRes.hasOwnProperty("MachineId")
      ? parseInt(objRes["MachineId"])
      : -1;
    const status = objRes.hasOwnProperty("status")
      ? objRes["status"].toString()
      : "success";
    switch (action) {
      case ActionID.LockMachine:
        if (connectionId === mMiddleServer.connectionId()) {
          onLockMachine(objRes);
        }
        break;
      case ActionID.UnlockMachine:
        if (
          (connectionId === mMiddleServer.connectionId() ||
            token === mUserInfo.Token) &&
          mLockedMachine &&
          mLockedMachine.deviceId === deviceId &&
          mLockedMachine.machineId === machineId &&
          status === "success"
        ) {
          onUnlockMachine(objRes);
        } else if (status === `failed`) {
          const errMsg =
            objRes.message !== null ? objRes.message : "未知的錯誤";
          showAlert({ title: `${errMsg}` });
        }
        break;
      case ActionID.LockSpyMachine:
        if (connectionId === mMiddleServer.connectionId()) {
          onLockSpyMachine(objRes);
        }
        break;
      case ActionID.UnlockSpyMachine:
        if (connectionId === mMiddleServer.connectionId() && mSpyingMachine) {
          onUnlockSpyMachine(objRes);
        }
        break;
      case ActionID.GameBtnDown:
        if (
          objRes.hasOwnProperty("BtnId") &&
          (connectionId === mMiddleServer.connectionId() ||
            token === mUserInfo.Token) &&
          mLockedMachine &&
          mLockedMachine.deviceId === deviceId &&
          mLockedMachine.machineId === machineId
        ) {
          onGameBtnDown(objRes);
        }
        break;
      case ActionID.GameBtnUp:
        if (
          objRes.hasOwnProperty("BtnId") &&
          (connectionId === mMiddleServer.connectionId() ||
            token === mUserInfo.Token) &&
          mLockedMachine &&
          mLockedMachine.deviceId === deviceId &&
          mLockedMachine.machineId === machineId
        ) {
          onGameBtnUp(objRes);
        }
        break;
      case ActionID.InScore:
      case ActionID.InTrialScore:
      case ActionID.InGuoZhaoScore:
      case ActionID.InSpecialScore:
        if (
          (connectionId === mMiddleServer.connectionId() ||
            token === mUserInfo.Token) &&
          mLockedMachine &&
          mLockedMachine.deviceId === deviceId &&
          mLockedMachine.machineId === machineId
        ) {
          onUpdateScore(objRes);
        }
        break;
      case ActionID.OutScore:
      case ActionID.OutTrialScore:
      case ActionID.OutGuoZhaoScore:
      case ActionID.OutSpecialScore:
        if (
          (connectionId === mMiddleServer.connectionId() ||
            token === mUserInfo.Token) &&
          mLockedMachine &&
          mLockedMachine.deviceId === deviceId &&
          mLockedMachine.machineId === machineId
        ) {
          onUpdateScore(objRes);
        }
        break;
      case ActionID.Gameplay:
        if (connectionId === mMiddleServer.connectionId()) {
          if (objRes.Action) delete objRes.Action;
          if (objRes.ConnectionId) delete objRes.ConnectionId;
          AppCtrl.setGameplay(objRes);
        }
        break;
      case ActionID.UpdateWinAward:
        if (objRes.Content) {
          const obj = objRes.Content;
          if (obj.hasOwnProperty("winAward")) {
            const bWinAward = Boolean(obj["winAward"]);
            mWinAward = bWinAward;
            if (mWinAward) {
              let title = "";
              let message = "";
              let okText = "";
              let TrialGuoZhaoMachine = "";
              let InGuoZhaoScore = mLockedMachine.inGuoZhaoScore;
              let PaidGuoZhaoScore =
                mLockedMachine.outGuoZhaoScore - InGuoZhaoScore;

              switch (Config.language) {
                case LANGUAGE_TYPE.zh_TW:
                  TrialGuoZhaoMachine = mLockedMachine.isTrial
                    ? "銀幣機台:"
                    : "金幣機台:";
                  message = "解招條件達成提示";
                  title = `${TrialGuoZhaoMachine}
                            開招贈分在退出機台後結算會進入您錢包
                            贈分:${PaidGuoZhaoScore.toLocaleString()}
                            過招條件:${"得獎解招"}`;
                  okText = "確定";
                  break;
                case LANGUAGE_TYPE.en_US:
                default:
                  TrialGuoZhaoMachine = mLockedMachine.isTrial
                    ? "Trial Machine:"
                    : "Gold:";
                  message = "Guo Zhao Hint";
                  title = `${TrialGuoZhaoMachine}
                            guo zhao will fill scores to your wallet after exit the machine 
                            award:${PaidGuoZhaoScore.toLocaleString()}
                            unlock:${"Win Award"}`;
                  okText = "OK";
                  break;
              }
              // do confirm
              showAlert({
                title: title,
                text: message,
                icon: "warning",
                showCancelButton: false,
                confirmButtonText: okText,
                confirmCb: function () {
                  resolve(true);
                },
              });
            }
          }
        }
        break;
      case ActionID.BonusState:
        if (objRes.Content) {
          const obj = objRes.Content;
          if (
            obj.hasOwnProperty("bonusType") &&
            obj.hasOwnProperty("joinBonus") &&
            obj.hasOwnProperty("winABase") &&
            obj.hasOwnProperty("winBBase") &&
            obj.hasOwnProperty("winAToBonus") &&
            obj.hasOwnProperty("winBToBonus") &&
            obj.hasOwnProperty("bonusNote")
          ) {
            const bonusType = parseInt(obj["bonusType"]);
            const joinBonus = Boolean(obj["joinBonus"]);
            const winABase = parseInt(obj["winABase"]);
            const winBBase = parseInt(obj["winBBase"]);
            const winAToBonus = parseInt(obj["winAToBonus"]);
            const winBToBonus = parseInt(obj["winBToBonus"]);
            const bonusNote = obj["bonusNote"];
            const newBonusStates = {
              bonusType: bonusType,
              joinBonus: joinBonus,
              winABase: winABase,
              winBBase: winBBase,
              winAToBonus: winAToBonus,
              winBToBonus: winBToBonus,
              bonusNote: bonusNote,
            };
            AppCtrl.setBonusState(newBonusStates);
          }
        }
        break;
      case ActionID.BetWinData:
        if (objRes.Action) delete objRes.Action;
        if (objRes.ConnectionId) delete objRes.ConnectionId;
        if (objRes.Content) {
          const obj = objRes.Content;
          if (
            obj.hasOwnProperty("spinCountPerRotate") &&
            obj.hasOwnProperty("betWins")
          ) {
            const betWinType = obj.betWinType;
            const spinCountPerRotate = obj.spinCountPerRotate;
            const totalBetDivided = obj.totalBetDivided;
            const betWins = [];
            for (let i = 0; i < obj.betWins.length; i++) {
              betWins.push(obj.betWins[i]);
            }
            const newNetWonDatas = {
              betWinType: betWinType,
              spinCountPerRotate: spinCountPerRotate,
              totalBetDivided: totalBetDivided,
              betWins: betWins,
            };
            AppCtrl.setBetWinData(newNetWonDatas);
          }
        }
        break;
      case ActionID.KickoutClient:
        if (connectionId === mMiddleServer.connectionId()) {
          let kickoutType = objRes.hasOwnProperty("KickoutType")
            ? objRes["KickoutType"].toString()
            : "-1";
          let DebugID = objRes.hasOwnProperty("DebugId")
            ? objRes["DebugId"].toString()
            : "-1";
          let msgContet = "";
          switch (kickoutType) {
            case "1":
              msgContet = `可能是機台有問題，請聯絡管理人員，或重新登入其他機台!!! EID:${DebugID}`;
              break;
            case "2":
              msgContet = `玩家太久沒動作，請按確認離開遊戲，並重新登入遊戲 EID:${DebugID}`;
              break;
            case "4":
              msgContet = `當前機台已有其他玩家遊戲, 如有疑問請聯繫客服 EID:${DebugID}`;
              break;
            default:
              msgContet = `玩家的連線中斷 kickoutType:${kickoutType} EID:${DebugID}`;
              break;
          }
          // stop middle server
          if (mMiddleServer) mMiddleServer.stop();
          // popup alert
          showAlert({ title: msgContet });
          // AppCtrl.alert(msgContet);
          AppCtrl.switchPage(EPage.reload);
        }
        break;
      case ActionID.Boosting:
        if (
          objRes.hasOwnProperty("Boosting") &&
          (connectionId === mMiddleServer.connectionId() ||
            token === mUserInfo.Token) &&
          mLockedMachine &&
          mLockedMachine.deviceId === deviceId &&
          mLockedMachine.machineId === machineId
        ) {
          const bBoosting = Boolean(objRes["Boosting"]);
          const objGBoosting = objRes["Boosting"];
          const newBoosting = {
            boosting: bBoosting,
          };
          AppCtrl.setBoosting(objGBoosting);
        }
        break;
      default:
        break;
    }
  }
}

const AppCtrl = new CAppCtrl();
AppCtrl.init();

module.exports = AppCtrl;
